import React, { useEffect, useState, useCallback, useRef } from "react";
import { useContext } from "react";
import { AuthContext } from "../AuthContext";
import axiosInstance from "../axiosConfig";
import "../assets/CSS/Header.css"; 
import logo from "../assets/Img/Logo-1.png";
import User from "../assets/Img/User.gif";
import Bell from "../assets/Img/BellIcon.png";
import moment from "moment-timezone";
import Dispatch from "../assets/Img/Dispatch.png";
import { NavLink } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2"; // ✅ Imported SweetAlert2
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_PATH || process.env.REACT_APP_API_URL || "https://wip.fibrebondindustries.com/backend";

// Frontend routing maps — mirrors backend PUCTURE_ROUTING_BY_EMPID / LOOPI_ROUTING_BY_EMPID
const PUCTURE_NEXT = { "4": "JITU SUPERVISOR", "6969": "SULEMAN SUPERVISOR", "6162": "ANIKET", "14": "RIYAZ" };
const LOOPI_NEXT   = { "4": "VIRAT (MAMA)", "1": "AMARJEET SUPERVISOR", "007": "RIYAZ" };
const getNextSupervisor = (routingType, empId) => {
  const map = routingType === "PUCTURE" ? PUCTURE_NEXT : LOOPI_NEXT;
  return map[String(empId)] || null;
};

const Header = ({ toggleSidebar, isSidebarVisible }) => {
  const { logout } = useContext(AuthContext);

  const user = JSON.parse(localStorage.getItem("user"));
  const [processData, setProcessData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [previewPhotoModalSrc, setPreviewPhotoModalSrc] = useState(null);

  // ── Lot Workflow: Done Form ──────────────────────────────────────────
  const [showDoneForm, setShowDoneForm]         = useState(false);
  const [doneFormProcess, setDoneFormProcess]   = useState(null);
  const [doneQtyProduced, setDoneQtyProduced]   = useState("");
  const [doneQtyDamaged, setDoneQtyDamaged]     = useState("0");
  const [doneQtyError, setDoneQtyError]         = useState("");
  const [donePhotos,      setDonePhotos]         = useState([]);
  const [doneNextSup,     setDoneNextSup]        = useState("");
  const [doneIsLastDept,  setDoneIsLastDept]     = useState(false);
  const [supervisorsList, setSupervisorsList]    = useState([]);
  const [submittingDone,  setSubmittingDone]     = useState(false);
  const [pucturePhotos, setPucturePhotos] = useState([]);
  const [loopiPhotos, setLoopiPhotos] = useState([]);

  // ── Lot Workflow: Reject Lot ─────────────────────────────────────────
  const [showRejectForm,    setShowRejectForm]   = useState(false);
  const [rejectProcess,     setRejectProcess]    = useState(null);
  const [rejectComment,     setRejectComment]    = useState("");
  const [rejectPhotos,      setRejectPhotos]     = useState([]);
  const [submittingReject,  setSubmittingReject] = useState(false);

  // ── Lot Workflow: Accept Lot ─────────────────────────────────────────
  const [showAcceptForm,    setShowAcceptForm]   = useState(false);
  const [acceptProcess,     setAcceptProcess]    = useState(null);
  const [acceptPhoto,       setAcceptPhoto]      = useState(null);
  const [submittingAccept,  setSubmittingAccept] = useState(false);

  // ── Lot Workflow: Issue Resolve ──────────────────────────────────────
  const [showResolveForm,     setShowResolveForm]   = useState(false);
  const [resolveProcess,      setResolveProcess]    = useState(null);
  const [resolveRemark,       setResolveRemark]     = useState("");
  const [resolvePhotos,       setResolvePhotos]     = useState([]);
  const [submittingResolve,   setSubmittingResolve] = useState(false);

  // ── Lot Workflow: Workflow Notifications bell ────────────────────────
  const [workflowNotifs,     setWorkflowNotifs]    = useState([]);
  const [showWorkflowNotif,  setShowWorkflowNotif] = useState(false);

  // ── Lot Workflow: Photo Routing Notifications ────────────────────────
  const [photoRoutingNotifs, setPhotoRoutingNotifs] = useState([]);
  const [showPhotoRoutingNotifs, setShowPhotoRoutingNotifs] = useState(false);
  // ── Forward Photo Modal ───────────────────────────────────────────────
  const [showForwardModal,    setShowForwardModal]    = useState(false);
  const [forwardNotif,        setForwardNotif]        = useState(null);   // the notification being forwarded
  const [forwardPhotos,       setForwardPhotos]       = useState([]);
  const [submittingForward,   setSubmittingForward]   = useState(false);
  const [delayedProcesses, setDelayedProcesses] = useState([]); 
  const [showDelayedModal, setShowDelayedModal] = useState(false); 
  const [delayed24hrProcesses, setDelayed24hrProcesses] = useState([]); 
  const [showDelayed24hrModal, setShowDelayed24hrModal] = useState(false); 
  
  const [dispatchOrders, setDispatchOrders] = useState([]);
  const [showDispatchModal, setShowDispatchModal] = useState(false);
  const [dispatchCount, setDispatchCount] = useState(0);
  const [remarkInput, setRemarkInput] = useState({});
  const [dispatchQtyInput, setDispatchQtyInput] = useState({});

  const [wipQueueData, setWipQueueData] = useState([]);
  const [showWipModal, setShowWipModal] = useState(false);
  const [wipSearchTerm, setWipSearchTerm] = useState("");
  const [selectedUploadItem, setSelectedUploadItem] = useState(null);
  const [uploadingWip, setUploadingWip] = useState(false);
  const [selectedQuickRoute, setSelectedQuickRoute] = useState("");
  const [selectedQuickFile, setSelectedQuickFile] = useState(null);
  const quickFileInputRef = useRef(null);

  const [currentTick, setCurrentTick] = useState(Date.now());
  useEffect(() => {
    const interval = setInterval(() => setCurrentTick(Date.now()), 1000);
    return () => clearInterval(interval);
  }, []);

  const [liveRemainingTimes, setLiveRemainingTimes] = useState({});

  const [workerAllocations, setWorkerAllocations] = useState([]);
  const [showAllocationModal, setShowAllocationModal] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [lotIdFilter, setLotIdFilter] = useState("");
  const filteredDispatchOrders = dispatchOrders.filter(order => lotIdFilter === "" || (order["LOT ID"] && order["LOT ID"].toString().includes(lotIdFilter)));

  const [processItemFilter, setProcessItemFilter] = useState("");
  const filteredProcessData = processData.filter(process => {
    // Hide processes that have already been marked as Completed
    if (process.CompletedTime != null) return false;
    // Remove rejected lots from the normal list (they are handled via notifications)
    if (process.LotAcceptStatus === "Rejected" && process.IsIssueResolved === false) return false;

    return processItemFilter === "" || 
      (process["ITEM NAME"] && process["ITEM NAME"].toString().toLowerCase().includes(processItemFilter.toLowerCase())) ||
      (process["PROCESS NAME"] && process["PROCESS NAME"].toString().toLowerCase().includes(processItemFilter.toLowerCase()));
  });

  const [delayedFilter, setDelayedFilter] = useState("");
  const filteredDelayedProcesses = delayedProcesses.filter(process => {
    return delayedFilter === "" || 
      (process["SupervisorName"] && process["SupervisorName"].toString().toLowerCase().includes(delayedFilter.toLowerCase())) ||
      (process["PROCESS NAME"] && process["PROCESS NAME"].toString().toLowerCase().includes(delayedFilter.toLowerCase())) ||
      (process["ITEM NAME"] && process["ITEM NAME"].toString().toLowerCase().includes(delayedFilter.toLowerCase()));
  });

  const [delayed24hrFilter, setDelayed24hrFilter] = useState("");
  const filteredDelayed24hrProcesses = delayed24hrProcesses.filter(process => {
    return delayed24hrFilter === "" || 
      (process["SupervisorName"] && process["SupervisorName"].toString().toLowerCase().includes(delayed24hrFilter.toLowerCase())) ||
      (process["PROCESS NAME"] && process["PROCESS NAME"].toString().toLowerCase().includes(delayed24hrFilter.toLowerCase())) ||
      (process["ITEM NAME"] && process["ITEM NAME"].toString().toLowerCase().includes(delayed24hrFilter.toLowerCase()));
  });

  const [srpInputs, setSrpInputs] = useState({});
  const [newNotifications, setNewNotifications] = useState([]);
  const [dismissedNotifications, setDismissedNotifications] = useState(() => {
    const saved = localStorage.getItem("dismissedNotifications");
    return saved ? JSON.parse(saved) : [];
  });

  const [processingId, setProcessingId] = useState(null);

  const handleDispatchQtyChange = (id, value) => {
    setDispatchQtyInput((prev) => ({ ...prev, [id]: value }));
  };
  
  const fetchProcessData = useCallback(async () => {
    try {
      const supervisorName = user?.Name;
      const response = await axiosInstance.get("/api/first-process-count", {
        params: { supervisorName },
      });
      setProcessData(response.data);
    } catch (error) {
      console.error("Error fetching process data:", error);
    }
  }, [user?.Name]);

  const fetchWorkflowNotifs = useCallback(async () => {
    if (!user?.Name) return;
    try {
      const params = { supervisorName: user.Name }; // Only fetch personal notifications for bell icon
      const res = await axiosInstance.get("/api/lot-workflow-notifications", { params });
      setWorkflowNotifs(res.data || []);
    } catch (err) { console.error("workflow notifs error:", err); }
  }, [user?.Name, user?.Auth]);

  const fetchPhotoRoutingNotifs = useCallback(async () => {
    if (!user?.EmployeeID && !user?.Name) return;
    const identifier = user?.EmployeeID || user?.Name;
    try {
      const res = await axiosInstance.get(`/api/photo-routing-notifications/${identifier}`);
      setPhotoRoutingNotifs(res.data.notifications || []);
    } catch (err) { console.error("photo routing notifs error:", err); }
  }, [user?.Name, user?.EmployeeID]);


  // Open upload & forward modal
  const handleOpenForward = (notif) => {
    setForwardNotif(notif);
    setForwardPhotos([]);
    setShowForwardModal(true);
  };

  // Submit forward photos to next in chain
  const handleForwardSubmit = async () => {
    if (forwardPhotos.length === 0) {
      toast.error("Please upload at least one photo before submitting.");
      return;
    }
    setSubmittingForward(true);
    try {
      const formData = new FormData();
      formData.append("ID",          forwardNotif.ID);
      formData.append("SenderEmpId", user?.EmployeeID || "");
      forwardPhotos.forEach(f => formData.append("forwardPhotos", f));
      const res = await axiosInstance.post("/api/photo-routing-forward", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      toast.success(res.data.message || "Photos forwarded successfully!");
      setShowForwardModal(false);
      setForwardNotif(null);
      setForwardPhotos([]);
      fetchPhotoRoutingNotifs();
    } catch (err) {
      console.error("Forward error:", err);
      toast.error(err.response?.data?.error || "Could not forward photos.");
    } finally {
      setSubmittingForward(false);
    }
  };

  // Legacy simple acknowledge (no photo)
  const acknowledgePhotoRouting = async (id) => {
    try {
      await axiosInstance.post("/api/photo-routing-acknowledge", { ID: id });
      fetchPhotoRoutingNotifs();
    } catch (err) {
      console.error("Acknowledge error:", err);
      Swal.fire("Error", "Could not acknowledge notification.", "error");
    }
  };

  const fetchSupervisors = useCallback(async () => {
    try {
      const res = await axiosInstance.get("/api/supervisors-list");
      setSupervisorsList(res.data || []);
    } catch (err) { console.error("supervisors-list error:", err); }
  }, []);

  const fetchWorkerAllocations = useCallback(async () => {
    if (user?.Auth === "Supervisor" && user?.Department) {
      try {
        const response = await axiosInstance.get("/api/worker-allocation-notification");
        const myDept = user.Department.trim();
        
        const pendingForMe = response.data.filter((alloc) => {
          const targetDept = alloc.To_Department ? alloc.To_Department.trim() : "";
          const currentStatus = alloc.Status ? alloc.Status : "Pending";
          
          return targetDept === myDept && (
            currentStatus === "Pending" || 
            currentStatus === "Occupied" || 
            (currentStatus === "Completed" && !alloc.satisfaction_status)
          );
        });
        
        setWorkerAllocations(pendingForMe);
      } catch (error) {
        console.error("Error fetching worker allocations:", error);
      }
    }
  }, [user?.Auth, user?.Department]);

  useEffect(() => {
    fetchProcessData();
    fetchWorkerAllocations();
    fetchWorkflowNotifs(); // Fetch lot workflow notifications
    fetchPhotoRoutingNotifs(); // Fetch photo routing notifications

    const fetchDelayedProcesses = async () => {
      try {
        const response = await axiosInstance.get("/api/delayed-processes");
        setDelayedProcesses(response.data); 
      } catch (error) {
        console.error("Error fetching delayed processes:", error);
      }
    };

    if (user?.Auth === "Admin") {
      fetchDelayedProcesses();
    }

    let allocInterval;
    if (user?.Auth === "Supervisor") {
      allocInterval = setInterval(() => {
        fetchWorkerAllocations();
      }, 10000);
    }

    // Poll workflow notifications every 30s
    const workflowInterval = setInterval(fetchWorkflowNotifs, 30000);

    const fetchWipQueueCount = async () => {
      try {
        const role = user?.Auth || "";
        const userId = user?.EmployeeID || "";
        if (userId && (role === "SuperAdmin" || role === "Admin" || ["4", "7", "6969", "6162", "14", "1", "007"].includes(String(userId)))) {
          const res = await axiosInstance.get(`/api/wip-photo-routing/queue?userId=${userId}&role=${role}`);
          if (res.data.success) {
            setWipQueueData(prevData => {
              const newData = res.data.data;
              if (prevData.length > 0 && newData.length > prevData.length) {
                const latestLot = newData[0];
                toast(`Lot ${latestLot.ItemName} has arrived in ${latestLot.CurrentProcessName} DEPARTMENT. Add photo(s) before pressing Done.`, {
                  icon: '🔔',
                  duration: 6000,
                  style: { background: '#3b82f6', color: '#fff', fontWeight: 'bold' }
                });
              }
              return newData;
            });
          }
        }
      } catch (error) {
        console.error("Error fetching WIP Queue count:", error);
      }
    };
    
    fetchWipQueueCount();
    const wipInterval = setInterval(fetchWipQueueCount, 30000);

    return () => {
      if (allocInterval) clearInterval(allocInterval);
      clearInterval(wipInterval);
      clearInterval(workflowInterval);
    };
  }, [user?.Name, user?.Auth, user?.EmployeeID, fetchProcessData, fetchWorkerAllocations, fetchWorkflowNotifs]);


  // ✅ Disable body scroll when any modal is open
  useEffect(() => {
    const isAnyModalOpen = showModal || showDelayedModal || showDelayed24hrModal || showDispatchModal || showAllocationModal || showWipModal;
    if (isAnyModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showModal, showDelayedModal, showDelayed24hrModal, showDispatchModal, showAllocationModal]);


  // ✅ ================= ACTION: CONFIRM ARRIVAL (SWEET ALERT) ================= ✅
  const handleAcceptWorker = async (id) => {
    const result = await Swal.fire({
      title: 'Confirm Arrival?',
      text: "Confirm that this worker has arrived in your department?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, confirm!'
    });

    if (!result.isConfirmed) return;

    setProcessingId(`accept_${id}`); 
    try {
      await axiosInstance.patch(`/api/worker-allocation/confirm/${id}`, {
        confirmed_by: user ? user.Name : "Supervisor"
      });
      Swal.fire('Confirmed!', 'Worker arrival confirmed. Status changed to Occupied!', 'success');
      fetchWorkerAllocations(); 
    } catch (error) {
      console.error("Error accepting worker:", error);
      Swal.fire('Error!', 'Failed to confirm arrival.', 'error');
    } finally {
      setProcessingId(null); 
    }
  };

  // ================= ACTION: WORK COMPLETED & SATISFACTION (SWEET ALERT WITH INPUT) ================= 

  // ACTION: ONLY MARK WORK AS COMPLETED
  const handleMarkCompleted = async (id) => {
    const result = await Swal.fire({
      title: 'Mark as Completed?',
      text: "The worker will become 'Available' again.",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#0d6efd',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Complete it!'
    });

    if (!result.isConfirmed) return;

    try {
      await axiosInstance.patch(`/api/worker-allocation/complete/${id}`);
      Swal.fire('Completed!', 'Work completed. Worker is free now. Please give your feedback.', 'success');
      fetchWorkerAllocations(); 
    } catch (error) {
      console.error("Error completing work:", error);
      Swal.fire('Error!', 'Failed to complete work.', 'error');
    }
  };

  // ACTION: GIVE SATISFACTION FEEDBACK
  const handleSatisfaction = async (id, status) => {
    try {
      const { value: comment } = await Swal.fire({
        title: `You selected '${status}'`,
        input: 'text',
        inputLabel: 'Any remarks? (Optional)',
        inputPlaceholder: 'Type your remarks here...',
        showCancelButton: true,
        confirmButtonColor: '#198754',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Submit Feedback'
      });

      if (comment === undefined) return; // User clicked Cancel

      await axiosInstance.patch(`/api/worker-allocation/satisfaction/${id}`, {
        satisfaction_status: status,
        comment: comment,
        rated_by: user ? user.Name : "Supervisor"
      });
      
      Swal.fire('Success!', 'Feedback submitted successfully!', 'success');
      fetchWorkerAllocations(); 
    } catch (error) {
      console.error("Error submitting feedback:", error);
      Swal.fire('Error!', 'Failed to submit feedback.', 'error');
    }
  };

  const handleConfirm = async (processName, id) => {
    // ── All others (not Monu) — Before Photo required on Confirm ──────────
    if (String(user?.EmployeeID) !== '4') {
      const { value: beforePhotoFile, isConfirmed } = await Swal.fire({
        title: '📷 Upload Before Photo',
        html: `
          <div style="font-family: 'Inter', sans-serif; text-align: center;">
            <p style="margin-bottom:16px;color:#64748b;font-size:14px;line-height:1.5;">
              Please capture or upload a <strong>Before Photo</strong> to confirm receipt of this lot.
            </p>
            <label for="swal-before-photo" id="dropzone-before-label" style="
              display: flex; flex-direction: column; align-items: center; justify-content: center;
              padding: 60px 24px; border: 2px dashed #cbd5e1; border-radius: 16px;
              background: #f8fafc; cursor: pointer; transition: all 0.2s ease; min-height: 250px;
            ">
              <div id="dropzone-before-content" style="display: flex; flex-direction: column; align-items: center;">
                <div style="background: #d1fae5; width: 64px; height: 64px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-bottom: 16px;">
                  <svg style="color: #10b981; width: 32px; height: 32px;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"></path>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"></path>
                  </svg>
                </div>
                <span style="font-size: 16px; font-weight: 700; color: #1e293b;">Tap to Capture Photo</span>
                <span style="font-size: 13px; color: #94a3b8; margin-top: 6px; font-weight: 500;">Supports JPG, PNG, HEIC</span>
              </div>
              <div id="swal-before-preview" style="display: none; width: 100%; text-align: center;">
                <img id="swal-before-img" src="" style="max-height: 220px; max-width: 100%; border-radius: 12px; object-fit: cover;" />
                <div id="swal-before-name" style="margin-top: 12px; font-size: 13px; font-weight: 600; color: #10b981;"></div>
              </div>
            </label>
            <input type="file" id="swal-before-photo" accept="image/jpeg,image/jpg,image/png,image/heic" capture="environment" style="display: none;" />
            <div id="swal-before-error" style="color: #ef4444; font-size: 13px; margin-top: 12px; display: none; font-weight: 600;"></div>
          </div>
        `,
        confirmButtonText: '✅ Confirm Lot',
        confirmButtonColor: '#198754',
        cancelButtonText: 'Cancel',
        showCancelButton: true,
        focusConfirm: false,
        width: '600px',
        customClass: { popup: 'swal-above-modal' },
        didOpen: () => {
          const swalContainer = document.querySelector('.swal2-container');
          swalContainer.style.zIndex = '99999';
          swalContainer.style.backdropFilter = 'blur(6px)';
          swalContainer.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
          Swal.getConfirmButton().disabled = true;
          Swal.getConfirmButton().style.opacity = '0.5';
          document.getElementById('swal-before-photo').addEventListener('change', (e) => {
            const file = e.target.files[0];
            if (!file) return;
            const errorEl = document.getElementById('swal-before-error');
            const preview = document.getElementById('swal-before-preview');
            const img     = document.getElementById('swal-before-img');
            const nameEl  = document.getElementById('swal-before-name');
            errorEl.style.display = 'none';
            if (file.size > 10 * 1024 * 1024) {
              errorEl.textContent   = 'File too large (max 10MB).';
              errorEl.style.display = 'block';
              return;
            }
            const reader = new FileReader();
            reader.onload = (ev) => {
              document.getElementById('dropzone-before-content').style.display = 'none';
              img.src               = ev.target.result;
              preview.style.display = 'block';
              nameEl.textContent    = `📎 ${file.name} (${(file.size/1024).toFixed(1)} KB)`;
            };
            reader.readAsDataURL(file);
            Swal.getConfirmButton().disabled = false;
            Swal.getConfirmButton().style.opacity = '1';
          });
        },
        preConfirm: () => {
          const file = document.getElementById('swal-before-photo').files[0];
          if (!file) {
            Swal.showValidationMessage('Please upload a before photo to confirm receipt.');
            return false;
          }
          return file;
        }
      });

      if (!isConfirmed || !beforePhotoFile) return;

      setProcessingId(`confirm_${id}`);
      try {
        const currentISTTime = moment().tz("Asia/Kolkata").format("DD/MM/YYYY : hh:mm A");
        const confirmBy = JSON.parse(localStorage.getItem("user"))?.Name;
        const formData = new FormData();
        formData.append("ID",          id);
        formData.append("ConfirmTime", currentISTTime);
        formData.append("ConfirmBy",   confirmBy);
        formData.append("BeforePhoto", beforePhotoFile);
        await axiosInstance.post("/api/confirm-process", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        Swal.fire('Confirmed!', 'Before photo uploaded and lot confirmed successfully!', 'success');
        fetchProcessData();
      } catch (error) {
        console.error("Error confirming process:", error);
        Swal.fire('Error!', error.response?.data?.error || "Failed to confirm lot.", 'error');
      } finally {
        setProcessingId(null);
      }

    } else {
      // ── MONU (ID: 4) — Simple confirm, no photo required ────────────────
      const { isConfirmed } = await Swal.fire({
        title: 'Confirm Lot',
        text: 'Are you sure you want to confirm receipt of this lot?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '✅ Yes, Confirm',
        confirmButtonColor: '#198754',
        cancelButtonText: 'Cancel'
      });

      if (!isConfirmed) return;

      setProcessingId(`confirm_${id}`);
      try {
        const currentISTTime = moment().tz("Asia/Kolkata").format("DD/MM/YYYY : hh:mm A");
        const confirmBy = JSON.parse(localStorage.getItem("user"))?.Name;
        const formData = new FormData();
        formData.append("ID",          id);
        formData.append("ConfirmTime", currentISTTime);
        formData.append("ConfirmBy",   confirmBy);
        // No BeforePhoto for non-Monu users
        await axiosInstance.post("/api/confirm-process", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        Swal.fire('Confirmed!', 'Lot confirmed successfully!', 'success');
        fetchProcessData();
      } catch (error) {
        console.error("Error confirming process:", error);
        toast.error(error.response?.data?.error || "Failed to confirm lot.");
      } finally {
        setProcessingId(null);
      }
    }
  };


  // ── Open Done Form Modal ─────────────────────────────────────────────
  const handleDone = (processObj) => {
    setDoneFormProcess(processObj);
    setDoneQtyProduced("");
    setDoneQtyDamaged("0");
    setDoneQtyError("");
    setDonePhotos([]);
    setDonePhotos([]);
    setPucturePhotos([]);
    setLoopiPhotos([]);
    setShowDoneForm(true);
    fetchSupervisors();
  };

  const handleDoneFormSubmit = async () => {
    setDoneQtyError(""); // clear previous error

    if (!doneQtyProduced || isNaN(doneQtyProduced) || parseInt(doneQtyProduced) < 0) {
      setDoneQtyError("Please enter a valid Quantity Produced."); 
      return;
    }

    const totalQty = parseInt(doneFormProcess.QUANTITY) || 0;
    const prod = parseInt(doneQtyProduced) || 0;
    const dmg = parseInt(doneQtyDamaged) || 0;

    if ((prod + dmg) !== totalQty) {
      setDoneQtyError(`Error: Qty Produced (${prod}) + Qty Damaged (${dmg}) must equal Total Qty (${totalQty}).`);
      return;
    }

    if (donePhotos.length === 0) {
      setDoneQtyError("Please upload at least 1 image before submitting.");
      return;
    }

    setSubmittingDone(true);
    try {
      const formData = new FormData();
      formData.append("ID",               doneFormProcess.ID);
      formData.append("QuantityProduced",  doneQtyProduced);
      formData.append("QuantityDamaged",   doneQtyDamaged || "0");
      formData.append("NextSupervisorName",""); // Managed by ERP LIVE
      formData.append("DoneSubmittedBy",   user?.Name);
      formData.append("CurrentEmpId",      user?.EmployeeID || "");
      formData.append("IsLastDept",        "true"); // Managed by ERP LIVE
      donePhotos.forEach(f => formData.append("photos", f));
      pucturePhotos.forEach(f => formData.append("pucturePhotos", f));
      loopiPhotos.forEach(f => formData.append("loopiPhotos", f));
      await axiosInstance.post("/api/done-process-form", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      toast.success("Lot completed successfully!");
      setShowDoneForm(false);
      fetchProcessData();
    } catch (err) {
      console.error("done-form error:", err);
      toast.error(err.response?.data?.error || "Failed to submit done form.");
    } finally { setSubmittingDone(false); }
  };

  // ── Accept Lot ────────────────────────────────────────────────────────
  const handleOpenAccept = (process) => {
    setAcceptProcess(process);
    setAcceptPhoto(null);
    setShowAcceptForm(true);
  };

  const handleAcceptFormSubmit = async () => {
    if (!acceptPhoto) {
      toast.error("Please upload a Before Photo to accept the lot.");
      return;
    }
    setSubmittingAccept(true);
    try {
      const formData = new FormData();
      formData.append("AcceptedBy", user?.Name);
      formData.append("BeforePhoto", acceptPhoto);
      await axiosInstance.post(`/api/accept-lot/${acceptProcess.ID}`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      toast.success("Lot accepted and confirmed successfully!");
      setShowAcceptForm(false);
      fetchProcessData();
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to accept lot.");
    } finally {
      setSubmittingAccept(false);
    }
  };

  // ── Open Reject Form ─────────────────────────────────────────────────
  const handleOpenReject = (processObj) => {
    setRejectProcess(processObj);
    setRejectComment("");
    setRejectPhotos([]);
    setShowRejectForm(true);
  };

  const handleRejectSubmit = async () => {
    if (!rejectComment.trim()) { toast.error("Rejection comment is required."); return; }
    setSubmittingReject(true);
    try {
      const formData = new FormData();
      formData.append("RejectedBy",    user?.Name);
      formData.append("RejectComment", rejectComment);
      rejectPhotos.forEach(f => formData.append("rejectPhotos", f));
      await axiosInstance.post(`/api/reject-lot/${rejectProcess.ID}`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      toast.success("Lot rejected. Notifications sent.");
      setShowRejectForm(false);
      fetchProcessData();
      fetchWorkflowNotifs();
    } catch (err) { toast.error(err.response?.data?.error || "Failed to reject lot."); }
    finally { setSubmittingReject(false); }
  };

  // ── Open Issue Resolve Form ───────────────────────────────────────────
  const handleOpenResolve = (processObj) => {
    setResolveProcess(processObj);
    setResolveRemark("");
    setResolvePhotos([]);
    setShowResolveForm(true);
  };

  const handleResolveSubmit = async () => {
    if (!resolveRemark.trim()) { toast.error("Resolution remark is required."); return; }
    setSubmittingResolve(true);
    try {
      const formData = new FormData();
      formData.append("ResolvedBy",   user?.Name);
      formData.append("ResolveRemark",resolveRemark);
      resolvePhotos.forEach(f => formData.append("resolvePhotos", f));
      await axiosInstance.post(`/api/resolve-issue/${resolveProcess.ID}`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      toast.success("Issue resolved! Sent back for re-verification.");
      setShowResolveForm(false);
      fetchProcessData();
      fetchWorkflowNotifs();
    } catch (err) { toast.error(err.response?.data?.error || "Failed to resolve issue."); }
    finally { setSubmittingResolve(false); }
  };

  // ── Re-Verify: Approve / Reject Again ────────────────────────────────
  const handleReVerify = async (notifId, confirmTimeNewId, decision) => {
    if (decision === "RejectedAgain") {
      await Swal.fire({
        title: "Reject Again",
        input: "textarea",
        inputLabel: "Enter rejection reason",
        inputPlaceholder: "Please explain why it's being rejected again...",
        inputAttributes: { "aria-label": "Enter rejection reason" },
        showCancelButton: true,
        confirmButtonColor: "#ef4444",
        confirmButtonText: "Reject Lot",
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
        didOpen: () => {
          const container = document.querySelector('.swal2-container');
          if (container) container.style.zIndex = '999999';
        },
        preConfirm: async (comment) => {
          if (!comment) {
            Swal.showValidationMessage("Please enter a reason.");
            return false;
          }
          try {
            await axiosInstance.patch(`/api/re-verify-lot/${confirmTimeNewId}`, {
              VerifiedBy: user?.Name, Decision: decision, RejectAgainComment: comment
            });
            await axiosInstance.patch(`/api/lot-workflow-notifications/dismiss/${notifId}`);
            return true;
          } catch (err) {
            Swal.showValidationMessage(err.response?.data?.error || "Failed.");
            return false;
          }
        }
      }).then((result) => {
        if (result.isConfirmed) {
          toast.success("Rejected again. Notifications sent.");
          fetchWorkflowNotifs();
          fetchProcessData();
        }
      });
    } else if (decision === "Approved") {
      await Swal.fire({
        title: "Approve Resolution?",
        text: "Are you sure you want to approve this resolution?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#10b981",
        confirmButtonText: "Yes, Approve",
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
        didOpen: () => {
          const container = document.querySelector('.swal2-container');
          if (container) container.style.zIndex = '999999';
        },
        preConfirm: async () => {
          try {
            await axiosInstance.patch(`/api/re-verify-lot/${confirmTimeNewId}`, {
              VerifiedBy: user?.Name, Decision: decision
            });
            await axiosInstance.patch(`/api/lot-workflow-notifications/dismiss/${notifId}`);
            return true;
          } catch (err) {
            Swal.showValidationMessage(err.response?.data?.error || "Failed.");
            return false;
          }
        }
      }).then((result) => {
        if (result.isConfirmed) {
          toast.success("Resolution approved!");
          fetchWorkflowNotifs();
          fetchProcessData();
        }
      });
    }
  };

  // ── Old handleDone kept as reference (now replaced) ──────────────────
  const _oldHandleDone = async (processName, id) => {
    // Step 1: Show After Photo upload modal
    const { value: formValues, isConfirmed } = await Swal.fire({
      title: '📷 Upload After Photo',
      html: `
        <div style="font-family: 'Inter', sans-serif; text-align: center;">
          <p style="margin-bottom:16px;color:#64748b;font-size:14px;line-height:1.5;">
            Please capture or upload an <strong>After Photo</strong> to verify completion.
          </p>
          
          <label for="swal-after-photo" id="dropzone-after-label" style="
            display: flex; flex-direction: column; align-items: center; justify-content: center;
            padding: 60px 24px; border: 2px dashed #cbd5e1; border-radius: 16px;
            background: #f8fafc; cursor: pointer; transition: all 0.2s ease; min-height: 250px;
          ">
            <div id="dropzone-after-content" style="display: flex; flex-direction: column; align-items: center;">
              <div style="background: #dbeafe; width: 64px; height: 64px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-bottom: 16px;">
                <svg style="color: #3b82f6; width: 32px; height: 32px;" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"></path>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"></path>
                </svg>
              </div>
              <span style="font-size: 16px; font-weight: 700; color: #1e293b;">Tap to Capture Photo</span>
              <span style="font-size: 13px; color: #94a3b8; margin-top: 6px; font-weight: 500;">Supports JPG, PNG, HEIC</span>
            </div>

            <div id="swal-after-preview" style="display: none; width: 100%; text-align: center;">
              <img id="swal-after-img" src="" style="max-height: 220px; max-width: 100%; border-radius: 12px; object-fit: cover; box-shadow: 0 8px 24px rgba(59, 130, 246, 0.15);" />
              <div id="swal-after-name" style="margin-top: 16px; font-size: 13px; font-weight: 600; color: #3b82f6; background: #eff6ff; padding: 6px 16px; border-radius: 20px; display: inline-block; border: 1px solid #dbeafe;"></div>
            </div>
          </label>
          
          <input type="file" id="swal-after-photo" accept="image/jpeg,image/jpg,image/png,image/heic" capture="environment" style="display: none;" />
          <div id="swal-after-error" style="color: #ef4444; font-size: 13px; margin-top: 16px; display: none; font-weight: 600; background: #fef2f2; padding: 10px 14px; border-radius: 8px; border: 1px solid #fee2e2;"></div>
        </div>
      `,
      confirmButtonText: '✅ Mark as Done',
      confirmButtonColor: '#0d6efd',
      cancelButtonText: 'Cancel',
      showCancelButton: true,
      focusConfirm: false,
      width: '600px',
      customClass: { popup: 'swal-above-modal' },
      didOpen: () => {
        // Fix z-index so Swal appears above Bootstrap modal, and add backdrop blur
        const swalContainer = document.querySelector('.swal2-container');
        swalContainer.style.zIndex = '99999';
        swalContainer.style.backdropFilter = 'blur(6px)';
        swalContainer.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';

        // Disable confirm until file chosen
        Swal.getConfirmButton().disabled = true;
        Swal.getConfirmButton().style.opacity = '0.5';

        document.getElementById('swal-after-photo').addEventListener('change', (e) => {
          const file = e.target.files[0];
          const errEl   = document.getElementById('swal-after-error');
          const preview = document.getElementById('swal-after-preview');
          const img     = document.getElementById('swal-after-img');
          const nameEl  = document.getElementById('swal-after-name');

          errEl.style.display   = 'none';
          preview.style.display = 'none';
          Swal.getConfirmButton().disabled = true;
          Swal.getConfirmButton().style.opacity = '0.5';

          if (!file) return;

          const allowedTypes = ['image/jpeg','image/jpg','image/png','image/heic'];
          if (!allowedTypes.includes(file.type) &&
              !file.name.toLowerCase().match(/\.(jpg|jpeg|png|heic)$/)) {
            errEl.textContent   = 'Unsupported photo format. Please upload a JPG, JPEG, or PNG file.';
            errEl.style.display = 'block';
            return;
          }
          if (file.size > 10 * 1024 * 1024) {
            errEl.textContent   = 'The selected photo exceeds the allowed file size (10 MB).';
            errEl.style.display = 'block';
            return;
          }

          const reader = new FileReader();
          reader.onload = (ev) => {
            document.getElementById('dropzone-after-content').style.display = 'none';
            document.getElementById('dropzone-after-label').style.border = '2px solid #3b82f6';
            document.getElementById('dropzone-after-label').style.background = '#fff';
            img.src               = ev.target.result;
            preview.style.display = 'block';
            nameEl.textContent    = `📎 ${file.name} (${(file.size/1024).toFixed(1)} KB)`;
          };
          reader.readAsDataURL(file);

          Swal.getConfirmButton().disabled = false;
          Swal.getConfirmButton().style.opacity = '1';
        });
      },
      preConfirm: () => {
        const file = document.getElementById('swal-after-photo').files[0];
        if (!file) {
          Swal.showValidationMessage('Please upload an after photo before completing this lot.');
          return false;
        }
        return file;
      }
    });

    if (!isConfirmed || !formValues) return;

    // Step 2: Send FormData with photo to backend
    setProcessingId(`done_${id}`);
    try {
      const currentISTTime = moment().tz("Asia/Kolkata").format("DD/MM/YYYY : hh:mm A");
      const confirmBy = JSON.parse(localStorage.getItem("user"))?.Name;

      const formData = new FormData();
      formData.append("ID",            id);
      formData.append("CompletedTime", currentISTTime);
      formData.append("ConfirmTime",   currentISTTime);
      formData.append("ConfirmBy",     confirmBy);
      formData.append("stage",         "after");
      formData.append("AfterPhoto",    formValues);

      await axiosInstance.post("/api/completedTime-process", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      Swal.fire('Done!', 'After photo uploaded and lot completed successfully!', 'success');
      fetchProcessData();
    } catch (error) {
      console.error("Error marking process as done:", error);
      Swal.fire('Error!', error.response?.data?.error || "The photo could not be uploaded. Please try again.", 'error');
    } finally {
      setProcessingId(null);
    }
  };

  const handleAdminDone = async (id) => {
    const result = await Swal.fire({
      title: 'Mark as Done?',
      text: 'Are you sure you want to mark this process as Done?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#198754',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, mark it!'
    });

    if (!result.isConfirmed) return;

    setProcessingId(`admindone_${id}`); 
    try {
      const currentISTTime = moment().tz("Asia/Kolkata").format("DD/MM/YYYY : hh:mm A");
      const confirmBy = JSON.parse(localStorage.getItem("user"))?.Name;

      await axiosInstance.post("/api/completedTime-process", {
        ID: id,
        CompletedTime: currentISTTime,
        ConfirmBy: confirmBy, 
      });

      Swal.fire('Success!', 'Process marked as Done', 'success');
      const response = await axiosInstance.get("/api/delayed-processes");
      setDelayedProcesses(response.data); 

      const response24hr = await axiosInstance.get("/api/delayed-24hr-processes");
      setDelayed24hrProcesses(response24hr.data); 
    } catch (error) {
      console.error("Error marking process as Done:", error);
      Swal.fire('Error!', error.response?.data?.error || "Failed to mark process as Done. Please try again.", 'error');
    } finally {
      setProcessingId(null); 
    }
  };

  const fetchDelayed24hrProcesses = async () => {
    try {
      const response = await axiosInstance.get("/api/delayed-24hr-processes");
      setDelayed24hrProcesses(response.data);
    } catch (error) {
      console.error("Error fetching 24hr delayed processes:", error);
    }
  };

  const handleWipUploadFromHeader = async (item) => {
    setSelectedUploadItem(item);
    setSelectedQuickRoute("");
    setSelectedQuickFile(null);
  };

  const handleHeaderUploadSubmit = async (e) => {
    e.preventDefault();
    const file = selectedQuickFile;
    const isFirstStep = selectedUploadItem.CurrentProcessName === 'PRESSING';

    if (!file) {
      Swal.fire("Required", "Please select a photo to upload.", "warning");
      return;
    }
    if (isFirstStep && !selectedQuickRoute) {
      Swal.fire("Required", "Please select a Route before completing.", "warning");
      return;
    }

    setUploadingWip(true);
    try {
      const formData = new FormData();
      formData.append("photo", file);
      formData.append("ItemName", selectedUploadItem.ItemName);
      formData.append("UploadedBy", user?.EmployeeID);
      formData.append("ProcessName", selectedUploadItem.CurrentProcessName);

      const uploadRes = await axiosInstance.post("/api/wip-photo-routing/upload-photo", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      if (uploadRes.data.success) {
        const completeRes = await axiosInstance.post("/api/wip-photo-routing/complete-step", {
          ItemName: selectedUploadItem.ItemName,
          CurrentAssigneeId: isFirstStep ? '4' : user?.EmployeeID,
          ProcessName: selectedUploadItem.CurrentProcessName,
          RouteType: selectedQuickRoute || selectedUploadItem.RouteType
        });
        
        if (completeRes.data.success) {
          Swal.fire({ icon: "success", title: "Success", text: "Photo uploaded and lot passed successfully!", timer: 2000, showConfirmButton: false });
          setSelectedUploadItem(null); // Go back to list
          
          if (user?.EmployeeID) {
            const role = user?.Auth || "";
            const res = await axiosInstance.get(`/api/wip-photo-routing/queue?userId=${user.EmployeeID}&role=${role}`);
            if (res.data.success) setWipQueueData(res.data.data);
          }
        }
      }
    } catch (err) {
      console.error("Quick upload error:", err);
      Swal.fire("Error", "Failed to upload and pass. Please try again.", "error");
    }
    setUploadingWip(false);
  };

  useEffect(() => {
    if (user?.Auth === "SuperAdmin") {
      fetchDelayed24hrProcesses();
    }
  }, [user?.Auth]);

  const fetchDispatchOrders = useCallback(async () => {
    try {
      const response = await axiosInstance.get("/api/dispatch-Notification");
      setDispatchOrders(response.data);
      setDispatchCount(response.data.length); 
    } catch (error) {
      console.error("Error fetching dispatch orders:", error);
    }
  }, []);

  useEffect(() => {
    fetchDispatchOrders();
  }, [fetchDispatchOrders]);

  const handlePartialDispatch = async (id) => {
    const dispatchQty = parseInt(dispatchQtyInput[id]);
    
    const result = await Swal.fire({
      title: 'Confirm Dispatch',
      text: `Are you sure you want to dispatch ${dispatchQty} units?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#198754',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Dispatch'
    });

    if (!result.isConfirmed) return;
  
    setProcessingId(`dispatch_${id}`); 
    try {
      await axiosInstance.patch(`/api/salesflow/partial-dispatch/${id}`, {
        Dispatch_Quantity: dispatchQty,
      });
      Swal.fire('Success!', `Dispatched ${dispatchQty} units successfully!`, 'success');
      fetchDispatchOrders(); 
      setDispatchQtyInput((prev) => ({ ...prev, [id]: "" })); 
    } catch (error) {
      console.error("Error in partial dispatch:", error);
      Swal.fire('Error!', 'Failed to dispatch. Try again.', 'error');
    } finally {
      setProcessingId(null); 
    }
  };
  
  const handleRemarkChange = (id, value) => {
    setRemarkInput((prev) => ({ ...prev, [id]: value }));
  };

  const handleRemarkSubmit = async (id) => {
    setProcessingId(`remark_${id}`); 
    try {
      const remark = remarkInput[id]; 
      await axiosInstance.patch(`/api/update-dispatch-remark/${id}`, {
        DispatchRemark: remark,
      });
      Swal.fire('Success!', 'Remark updated successfully!', 'success');
      fetchDispatchOrders(); 
    } catch (error) {
      console.error("Error updating remark:", error);
      Swal.fire('Error!', 'Failed to update remark.', 'error');
    } finally {
      setProcessingId(null); 
    }
  };
  
 useEffect(() => {
  if (user?.EmployeeID !== "1017") return;

  const interval = setInterval(async () => {
    try {
      const response = await axiosInstance.get("/api/notifications/panni-packing-completed");
      const newRecords = response.data;

      if (newRecords.length > 0) {
        const filtered = newRecords.filter((note) => !dismissedNotifications.includes(note.ID));
        if (filtered.length > 0) {
          setNewNotifications(filtered);
        }
      }
    } catch (error) {
      console.error("Push notification fetch error:", error);
    }
  }, 10000); 

  return () => clearInterval(interval);
}, [user?.EmployeeID, dismissedNotifications]);

const handleDismissNotification = async (ID) => {
  const srpNo = srpInputs[ID] || "";

  if (!srpNo.trim()) {
    Swal.fire('Warning!', 'Please enter SRP NO before proceeding.', 'warning');
    return;
  }

  setProcessingId(`srp_${ID}`); 
  try {
     await axiosInstance.patch(`/api/notifications/mark-sent/${ID}`, {
      SRP_NO: srpNo.trim(),
    });

    const updatedDismissed = [...dismissedNotifications, ID];
    setDismissedNotifications(updatedDismissed);
    localStorage.setItem("dismissedNotifications", JSON.stringify(updatedDismissed));
    setNewNotifications((prev) => prev.filter((n) => n.ID !== ID));
  } catch (error) {
    console.error("Error marking notification as sent:", error);
    Swal.fire('Error!', 'Failed to update SRP.', 'error');
  } finally {
    setProcessingId(null); 
  }
};

function formatDuration(seconds) {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  return `${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
}

function getRemainingWorkingSeconds(startTime, totalHours) {
  const WORK_START = 10; 
  const WORK_END = 19;   

  let current = moment(startTime);
  let remainingSeconds = totalHours * 3600;
  const now = moment();

  while (current.isBefore(now) && remainingSeconds > 0) {
    const workStart = current.clone().hour(WORK_START).minute(0).second(0);
    const workEnd = current.clone().hour(WORK_END).minute(0).second(0);

    if (current.isBefore(workStart)) {
      current = workStart;
    } else if (current.isSameOrAfter(workEnd)) {
      current.add(1, "day").hour(WORK_START).minute(0).second(0);
    } else {
      const effectiveEnd = moment.min(workEnd, now);
      const seconds = effectiveEnd.diff(current, "seconds");
      remainingSeconds -= seconds;
      current = effectiveEnd;
    }
  }

  return Math.max(remainingSeconds, 0);
}

useEffect(() => {
  const interval = setInterval(() => {
    const updated = {};
      [...processData, ...delayedProcesses, ...delayed24hrProcesses].forEach((item) => {
      const startTime = moment(item.Updated_Time, "DD/MM/YYYY : hh:mm A");
      const seconds = getRemainingWorkingSeconds(startTime, item.Remaining_Hours);  
      updated[item.ID] = seconds;
    });

    setLiveRemainingTimes(updated);
  }, 1000); 

  return () => clearInterval(interval);
}, [processData,  delayedProcesses, delayed24hrProcesses]);


  // Routing Visibility Logic
  const currentUser = JSON.parse(localStorage.getItem("user"));
  const isMonu = String(currentUser?.EmployeeID) === "4" || currentUser?.Name?.toUpperCase() === "MONU";
  const currentLotId = doneFormProcess?.["ITEM NAME"];

  const hasPuctureNotif = photoRoutingNotifs.some(n => n.LOT_ID === currentLotId && n.RoutingType === "PUCTURE");
  const hasLoopiNotif = photoRoutingNotifs.some(n => n.LOT_ID === currentLotId && n.RoutingType === "LOOPI");

  const pendingPhotoNotifs = photoRoutingNotifs.filter(n => n.Status === 'Pending');

  const showPuctureRouting = isMonu || hasPuctureNotif;
  const showLoopiRouting = isMonu || hasLoopiNotif;

  return (
    <div>
    <div id="alertPlaceholder"></div>
    <style>{`
      @keyframes slideInRight {
        from { transform: translateX(120%); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }

      @keyframes slideOutLeft {
        from { transform: translateX(0); opacity: 1; }
        to { transform: translateX(-120%); opacity: 0; }
      }

      .notification {
        animation: slideInRight 0.4s ease forwards;
        transition: all 0.4s ease;
      }

      .notification.hide {
        animation: slideOutLeft 0.4s ease forwards;
      }
    `}</style>
       <div
        style={{
          position: "fixed",
          top: "10px",
          bottom: "10px",
          right: "20px",
          zIndex: 9999,
          maxHeight: "100%",   
          overflowY: "auto",   
          paddingRight: "10px"
        }}
      >
      {newNotifications.map((note, idx) => (
        <div
          key={note.ID}
          className={`alert alert-info alert-dismissible fade show  notification ${
            dismissedNotifications.includes(note.ID) ? "hide" : ""
          }`}
          style={{
            marginBottom: "10px", 
            minWidth: "320px",
            padding: "15px",
            borderRadius: "8px",
          }}
          role="alert"
        >
          📦 <strong>PANNI PACKING DONE</strong><br />
          <strong>LOT:</strong> {note["LOT ID"]} <br />
          <strong>Qty:</strong> {note.QUANTITY} <br />
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "9px" }}>
          <input
              type="text"
              placeholder="Enter SRP NO"
              className="form-control form-control-sm me-2"
              value={srpInputs[note.ID] || ""}
              onChange={(e) =>
                setSrpInputs((prev) => ({ ...prev, [note.ID]: e.target.value }))
              }
              style={{width:"auto"}}
              disabled={processingId !== null}
            />
            <button
              type="button"
              className="btn btn-sm btn-success"
              onClick={() => handleDismissNotification(note.ID)}
              disabled={processingId !== null}
            >
              {processingId === `srp_${note.ID}` ? (
                <><span className="spinner-border spinner-border-sm me-1"></span>Processing...</>
              ) : "SRP DONE"}
            </button>
          </div>
        </div>
      ))}
      </div>

      <nav className="navbar navbar-expand-lg bg-body-tertiary">
        <div className="container-fluid">
          <button
            className="btn btn-link toggleBtn"
            onClick={toggleSidebar}
            style={{ fontSize: "24px", border: "none", cursor: "pointer", marginRight: "15px", marginLeft: "10px" }}
          >
            <i className="bi bi-list d-none d-lg-inline-block"></i>
            <i className={`bi ${isSidebarVisible ? "bi-x-lg" : "bi-list"} d-lg-none`}></i>
          </button>

          <a className="navbar-brand d-none d-lg-block">
            <img src={logo} alt="Fibre Bond Logo" style={{ height: "40px", width: "auto", display: "none" }} />
          </a>

          {/* Right-aligned ALWAYS VISIBLE elements: Bells + Profile + Hamburger */}
          <div className="d-flex align-items-center ms-auto gap-2 gap-lg-3 order-lg-last">
            {/* Bells */}
            <div className="d-flex align-items-center gap-1 gap-md-2">
              {user?.Auth === "Supervisor" && ["MONU", "Sudhir CK"].includes(user?.Name) && (
                <a name="Dispatch" id="Dispatch" className="btn p-1" href="#" role="button" onClick={() => setShowDispatchModal(true)}>
                  <span style={{ color: "red", fontWeight: "bold" }}>{dispatchCount}</span>
                  <img src={Dispatch} className="img-fluid rounded-top" alt="Dispatch Icon" style={{ height: "20px", width: "34px", marginLeft: "4px" }} />
                </a>
              )}
              
              {user?.Auth === "Supervisor" && (
                <a
                  name="WorkerAllocationNotification"
                  className="btn p-1"
                  href="#"
                  role="button"
                  title="Worker Confirmation"
                  onClick={() => setShowAllocationModal(true)}
                >
                  <span style={{ color: "red", fontWeight: "bold" }}>{workerAllocations.length}</span>
                  <img
                    src={User}
                    className="img-fluid rounded-circle shadow-sm border border-secondary"
                    alt="Worker Icon"
                    style={{ height: "24px", width: "24px", marginLeft:"4px" }}
                  />
                </a>
              )}

              {/* WIP Photo Queue Notification */}
              
              {/* {(user?.Auth === "SuperAdmin" || user?.Auth === "Admin" || ["4", "7", "6969", "6162", "14", "1", "007"].includes(String(user?.EmployeeID))) && (
                <a className="btn p-1 position-relative" title="WIP Photo Queue" style={{ marginRight: "12px", display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => setShowWipModal(true)}>
                  <span style={{ color: "red", fontWeight: "bold" }}>{wipQueueData.length}</span>
                  <i className="bi bi-images ms-1" style={{ fontSize: "22px", color: "#6366f1", filter: "drop-shadow(0 2px 4px rgba(99,102,241,0.3))" }}></i>
                </a>
              )}
              */}

              {user?.Auth === "Supervisor" && (
                <a name="Notification" id="Notification" className="btn p-1" href="#" role="button" onClick={() => setShowModal(true)}>
                  <span style={{ color: "red", fontWeight: "bold" }}>{filteredProcessData.length}</span>
                  <img src={Bell} className="img-fluid rounded-top" alt="Bell Icon" style={{ height: "20px", width: "20px", marginLeft: "4px" }} />
                </a>
              )}
              {/* Photo Routing Notifications - Camera Icon */}
              {(user?.Auth === "Supervisor" || user?.Auth === "Admin" || user?.Auth === "SuperAdmin") && pendingPhotoNotifs.length > 0 && (
                <a className="btn p-1 position-relative" href="#" role="button" title="Photo Routing Alerts" onClick={() => setShowPhotoRoutingNotifs(true)}>
                  <span style={{ color: "#3b82f6", fontWeight: "bold", marginRight: 2 }}>{pendingPhotoNotifs.length}</span>
                  <i className="bi bi-camera-fill text-primary ms-1" style={{ fontSize: "20px" }}></i>
                </a>
              )}

              {/* Workflow Rejection/ReVerify bell — Supervisors + Admins + SuperAdmin */}
              {(user?.Auth === "Supervisor" || user?.Auth === "Admin" || user?.Auth === "SuperAdmin") && workflowNotifs.length > 0 && (
                <a className="btn p-1 position-relative" href="#" role="button" title="Lot Workflow Alerts" onClick={() => setShowWorkflowNotif(true)}>
                  <span style={{ color: "orange", fontWeight: "bold", marginRight: 2 }}>{workflowNotifs.length}</span>
                  <i className="bi bi-exclamation-circle-fill text-warning ms-1" style={{ fontSize: "18px" }}></i>
                </a>
              )}
              {user?.Auth === "Admin" && (
                <a name="AdminNotification" id="AdminNotification" className="btn p-1" href="#" role="button" onClick={() => setShowDelayedModal(true)}>
                  <span style={{ color: "red", fontWeight: "bold" }}>{delayedProcesses.length}</span>
                  <img src={Bell} className="img-fluid rounded-top" alt="Bell Icon" style={{ height: "20px", width: "20px", marginLeft: "4px" }} />
                </a>
              )}
              {user?.Auth === "SuperAdmin" && user?.Name !== "Sandeep Maintenance" && (
                <a name="SuperAdminNotification" id="SuperAdminNotification" className="btn p-1" href="#" role="button" onClick={() => setShowDelayed24hrModal(true)}>
                  <span style={{ color: "red", fontWeight: "bold" }}>{delayed24hrProcesses.length}</span>
                  <img src={Bell} className="img-fluid rounded-top" alt="Bell Icon" style={{ height: "20px", width: "20px", marginLeft: "4px" }} />
                </a>
              )}
            </div>

            {/* Profile */}
            <div className="d-flex align-items-center gap-2 justify-content-end">
              <span className="fw-medium text-secondary d-none d-lg-inline">
                Welcome, {user?.Name}!
              </span>
              <div className="dropdown">
                <a className="d-flex align-items-center text-decoration-none dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false" style={{ cursor: "pointer" }}>
                  <img src={User} alt="Profile" className="rounded-circle shadow-sm border" style={{ width: "36px", height: "36px", objectFit: "cover" }} />
                </a>
                <ul className="dropdown-menu dropdown-menu-end shadow mt-2">
                  <li><a className="dropdown-item text-danger fw-semibold" onClick={logout} style={{ cursor: "pointer" }}>Logout</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {showAllocationModal && (() => {
        const filteredWorkers = workerAllocations.filter((alloc) => {
          const searchLower = searchTerm.toLowerCase();
          const matchesSearch =
            (alloc.Worker_Name || "").toLowerCase().includes(searchLower) ||
            (alloc.From_Dep || "").toLowerCase().includes(searchLower) ||
            (alloc.ID || "").toString().includes(searchLower);

          const currentStatus = alloc.Status || "Pending";
          const matchesStatus = statusFilter === "All" || currentStatus === statusFilter;

          return matchesSearch && matchesStatus;
        });

        return (
          <div 
            className="modal fade show" 
            tabIndex="-1" 
            style={{ 
              display: "block", 
              backgroundColor: "rgba(0,0,0,0.6)", 
              zIndex: 1055, 
              position: "fixed", 
              top: 0, left: 0, width: "100%", height: "100%",
              backdropFilter: "blur(5px)" 
            }}
          >
            <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
              <div className="modal-content shadow-lg border-0 rounded-4">
                
                {/* Modal Header */}
                <div className="modal-header bg-primary bg-gradient text-white border-0 rounded-top-4 px-4 py-3">
                  <h5 className="modal-title d-flex align-items-center gap-2 fw-bold mb-0" style={{ letterSpacing: "0.5px" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-people-fill" viewBox="0 0 16 16">
                      <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"/>
                    </svg>
                    Worker Confirmation
                  </h5>
                  <button type="button" className="btn-close btn-close-white opacity-75 shadow-none" onClick={() => setShowAllocationModal(false)}></button>
                </div>

                {/* Modal Body */}
                <div className="modal-body p-4 bg-light">
                  
                  {/* Filters Section */}
                  {workerAllocations.length > 0 && (
                    <div className="row mb-4 align-items-center bg-white p-3 rounded-3 shadow-sm border mx-0">
                      <div className="col-md-8 mb-3 mb-md-0">
                        <div className="input-group">
                          <span className="input-group-text bg-light border-end-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search text-muted" viewBox="0 0 16 16">
                              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                            </svg>
                          </span>
                          <input
                            type="text"
                            className="form-control border-start-0 bg-light shadow-none"
                            placeholder="Search by ID, Name, or Department..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <select
                          className="form-select bg-light shadow-none fw-medium text-secondary"
                          value={statusFilter}
                          onChange={(e) => setStatusFilter(e.target.value)}
                        >
                          <option value="All">View All Statuses</option>
                          <option value="Pending">Pending Arrivals</option>
                          <option value="Occupied">Currently Occupied</option>
                          <option value="Completed">Completed</option>
                        </select>
                      </div>
                    </div>
                  )}

                  {/* Table Section */}
                  {workerAllocations.length === 0 ? (
                    // Case 1: No workers assigned at all
                    <div className="text-center py-5 bg-white rounded-3 shadow-sm border">
                      <div className="p-3 bg-light rounded-circle d-inline-block mb-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor" className="bi bi-inbox text-primary opacity-75" viewBox="0 0 16 16">
                          <path d="M4.98 4a.5.5 0 0 0-.39.188L1.54 8H6a.5.5 0 0 1 .5.5 1.5 1.5 0 1 0 3 0A.5.5 0 0 1 10 8h4.46l-3.05-3.812A.5.5 0 0 0 11.02 4zM3.81.563A1.5 1.5 0 0 1 4.98 0h6.04a1.5 1.5 0 0 1 1.17.563l3.7 4.625a.5.5 0 0 1 .106.304l-.228 6.203a1.5 1.5 0 0 1-1.498 1.305H1.73a1.5 1.5 0 0 1-1.498-1.305L.004 5.492a.5.5 0 0 1 .106-.304zM12.18 1H3.82L1 4.5V14h14V4.5z"/>
                        </svg>
                      </div>
                      <h5 className="fw-bold text-dark">No Pending Workers</h5>
                      <p className="text-muted mb-0">When someone assigns a worker to your department, they will appear here.</p>
                    </div>
                  ) : filteredWorkers.length === 0 ? (
                    // Case 2: Workers exist, but filtered out
                    <div className="text-center py-5 bg-white rounded-3 shadow-sm border">
                      <h5 className="fw-bold text-secondary">No matching results</h5>
                      <p className="text-muted mb-0">Try adjusting your search or filters.</p>
                    </div>
                  ) : (
                    // Case 3: Data table
                    <div className="table-responsive rounded-3 shadow-sm border bg-white overflow-hidden">
                      <table className="table table-hover text-center align-middle mb-0">
                        <thead className="bg-dark text-white">
                          <tr>
                            <th className="py-3 text-white fw-semibold border-0">ID</th>
                            <th className="py-3 text-white fw-semibold border-0">From Department</th>
                            <th className="py-3 text-white fw-semibold border-0">Worker Name</th>
                            <th className="py-3 text-white fw-semibold border-0">Status</th>
                            <th className="py-3 text-white fw-semibold border-0">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredWorkers.map((alloc) => (
                            <tr key={alloc.ID} style={{ transition: "all 0.2s ease" }}>
                              <td className="fw-bold text-muted">#{alloc.ID}</td>
                              <td className="fw-medium text-dark">{alloc.From_Dep}</td>
                              <td>
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                  <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" style={{ width: "32px", height: "32px", fontSize: "14px", fontWeight: "bold" }}>
                                    {(alloc.Worker_Name || "W").charAt(0).toUpperCase()}
                                  </div>
                                  <span className="text-primary fw-bold">{alloc.Worker_Name}</span>
                                </div>
                              </td>
                              <td>
                                <span className={`badge px-3 py-2 rounded-pill fw-semibold shadow-sm d-inline-flex align-items-center gap-1 border ${
                                  alloc.Status?.trim() === 'Occupied' ? 'bg-warning text-dark border-warning' : 
                                  alloc.Status?.trim() === 'Completed' ? 'bg-success bg-opacity-10 text-success border-success' : 
                                  'bg-info bg-opacity-10 text-info border-info'
                                }`}>
                                  
                                  {alloc.Status?.trim() === 'Occupied' ? (
                                    <>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-building-fill" viewBox="0 0 16 16">
                                        <path d="M3 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h3v-3.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V16h3a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H3Zm1 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5ZM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5ZM4 8.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Zm-7 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Z"/>
                                      </svg>
                                      Occupied
                                    </>
                                  ) : alloc.Status?.trim() === 'Completed' ? (
                                    <>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check-all" viewBox="0 0 16 16">
                                        <path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z"/>
                                      </svg>
                                      Completed
                                    </>
                                  ) : (
                                    <>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-hourglass-split" viewBox="0 0 16 16">
                                        <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 14v1h1a.5.5 0 0 1 0 1h-11zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2h-7zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48V8.35zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.35z"/>
                                      </svg>
                                      Pending
                                    </>
                                  )}
                                </span>
                              </td>
                              <td>
                                {/* PRD Step 4: Confirm Arrival */}
                                {(!alloc.Status || alloc.Status === "Pending") && (
                                  <button
                                    className="btn btn-success btn-sm px-4 d-inline-flex align-items-center justify-content-center gap-2 shadow-sm rounded-pill"
                                    onClick={() => handleAcceptWorker(alloc.ID)}
                                  >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                    </svg>
                                    Confirm Arrival
                                  </button>
                                )}

                                {/* PRD Step 5a: ONLY Work Completed */}
                                {alloc.Status === "Occupied" && (
                                  <button
                                    className="btn btn-primary btn-sm px-4 d-inline-flex align-items-center justify-content-center gap-2 shadow-sm rounded-pill"
                                    onClick={() => handleMarkCompleted(alloc.ID)}
                                  >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-play-circle-fill" viewBox="0 0 16 16">
                                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z"/>
                                    </svg>
                                    Mark Completed
                                  </button>
                                )}

                                {/* PRD Step 5b: Satisfaction Feedback (Appears after completion) */}
                                {alloc.Status?.trim() === "Completed" && !alloc.satisfaction_status && (
                                  <div className="mt-2 p-3 bg-light border border-warning rounded-3 shadow-sm d-flex flex-column align-items-center transition-all">
                                    
                                    {/* Feedback Pending Badge */}
                                    <span className="badge bg-warning text-dark mb-3 px-3 py-2 rounded-pill d-inline-flex align-items-center gap-2 shadow-sm" style={{ fontSize: "0.85rem" }}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-star-fill text-dark" viewBox="0 0 16 16">
                                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                                      </svg>
                                      Action Required: Rate Worker
                                    </span>

                                    {/* Buttons Container */}
                                    <div className="d-flex flex-wrap gap-2 justify-content-center w-100">
                                      
                                      {/* Satisfied Button */}
                                      <button
                                        className="btn btn-success btn-sm px-3 py-2 d-inline-flex align-items-center justify-content-center gap-2 shadow-sm rounded-pill fw-semibold flex-grow-1 hover-zoom"
                                        onClick={() => handleSatisfaction(alloc.ID, "Satisfied")}
                                        disabled={processingId !== null}
                                        style={{ minWidth: "120px" }}
                                      >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-hand-thumbs-up-fill" viewBox="0 0 16 16">
                                          <path d="M6.956 1.745C7.021.81 7.908.087 8.864.325l.261.066c.463.116.874.456 1.012.965.22.816.533 2.511.062 4.51a10 10 0 0 1 .443-.051c.713-.065 1.669-.072 2.516.21.518.173.994.681 1.2 1.273.184.532.16 1.162-.234 1.733q.086.18.138.363c.077.27.113.567.113.856s-.036.586-.113.856c-.039.135-.09.273-.16.404.169.387.107.82-.003 1.148a3.2 3.2 0 0 1-.488.901c.054.152.076.312.076.465 0 .305-.089.625-.253.912C13.1 15.522 12.437 16 11.5 16H8c-.605 0-1.07-.081-1.466-.218a4.8 4.8 0 0 1-.97-.484l-.048-.03c-.504-.307-.999-.609-2.068-.722C2.682 14.464 2 13.846 2 13V9c0-.85.685-1.432 1.357-1.615.849-.232 1.574-.787 2.132-1.41.56-.627.914-1.28 1.039-1.639.199-.575.356-1.539.428-2.59z"/>
                                        </svg>
                                        Satisfied
                                      </button>

                                      {/* Not Satisfied Button */}
                                      <button
                                        className="btn btn-danger btn-sm px-3 py-2 d-inline-flex align-items-center justify-content-center gap-2 shadow-sm rounded-pill fw-semibold flex-grow-1 hover-zoom"
                                        onClick={() => handleSatisfaction(alloc.ID, "Not Satisfied")}
                                        disabled={processingId !== null}
                                        style={{ minWidth: "120px" }}
                                      >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-hand-thumbs-down-fill" viewBox="0 0 16 16">
                                          <path d="M6.956 14.255c.065.935.952 1.658 1.908 1.42l.261-.065a1.38 1.38 0 0 0 1.012-.965c.22-.816.533-2.512.062-4.51.136.02.285.037.443.051.713.065 1.669.071 2.516-.211.518-.173.994-.68 1.2-1.272a1.9 1.9 0 0 0-.234-1.734c.058-.118.103-.242.138-.362.077-.27.113-.568.113-.857 0-.288-.036-.585-.113-.856a2 2 0 0 0-.16-.403c.169-.387.107-.82-.003-1.148a3.2 3.2 0 0 0-.488-.901c.054-.152.076-.312.076-.465 0-.305-.089-.625-.253-.912C13.1.478 12.437 0 11.5 0H8c-.605 0-1.07.081-1.466.218a4.8 4.8 0 0 0-.97.484l-.048.03c-.504.307-.999.609-2.068.722C2.682 1.536 2 2.154 2 3v4c0 .85.685 1.432 1.357 1.615.849.232 1.574.787 2.132 1.41.56.626.914 1.28 1.039 1.638.199.575.356 1.539.428 2.59z"/>
                                        </svg>
                                        Not Satisfied
                                      </button>

                                    </div>
                                  </div>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}

                </div>
                
                {/* Modal Footer */}
                <div className="modal-footer border-0 bg-light rounded-bottom-4 px-4 py-3">
                  <button className="btn btn-secondary px-5 rounded-pill shadow-sm fw-medium" onClick={() => setShowAllocationModal(false)} disabled={processingId !== null}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── WIP PHOTO QUEUE NOTIFICATION MODAL ── */}
      {showWipModal && (() => {
        const filteredWipQueue = wipQueueData.filter((item) => {
          const searchLower = wipSearchTerm.toLowerCase();
          return (
            (item.ItemName || "").toLowerCase().includes(searchLower) ||
            (item.CurrentProcessName || "").toLowerCase().includes(searchLower)
          );
        });

        return (
          <div 
            className="modal fade show" 
            tabIndex="-1" 
            style={{ 
              display: "block", 
              backgroundColor: "rgba(0,0,0,0.6)", 
              zIndex: 1055, 
              position: "fixed", 
              top: 0, left: 0, width: "100%", height: "100%",
              backdropFilter: "blur(5px)" 
            }}
          >
            <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
              <div className={selectedUploadItem ? "" : "modal-content shadow-lg border-0 rounded-4"} style={selectedUploadItem ? { backgroundColor: "#ffffff", borderRadius: "24px", width: "100%", maxWidth: "800px", margin: "0 auto", maxHeight: "85vh", display: "flex", flexDirection: "column", boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)", pointerEvents: "auto" } : {}}>
                {selectedUploadItem ? (
                  <form onSubmit={handleHeaderUploadSubmit} style={{ display: 'flex', flexDirection: 'column', height: '100%', maxHeight: '85vh', margin: 0 }}>
                    {/* Premium Modal Header */}
                    <div style={{ padding: "24px 32px", borderBottom: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                        <button 
                          type="button"
                          className="btn btn-light rounded-circle shadow-sm"
                          onClick={() => setSelectedUploadItem(null)} 
                          style={{ width: "42px", height: "42px", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #e2e8f0" }}
                        >
                          <i className="bi bi-arrow-left fs-5"></i>
                        </button>
                        <div>
                          <h3 style={{ margin: 0, fontSize: "22px", fontWeight: "800", color: "#1e293b" }}>
                            Lot Processing
                          </h3>
                          <div style={{ fontSize: "15px", color: "#64748b", marginTop: "4px", fontWeight: "500" }}>
                            ID: <span style={{ color: "#3b82f6", fontWeight: "700" }}>{selectedUploadItem.ItemName}</span>
                          </div>
                        </div>
                      </div>
                      <button 
                        type="button"
                        onClick={() => { setShowWipModal(false); setSelectedUploadItem(null); }} 
                        style={{ background: "#f1f5f9", border: "none", width: "40px", height: "40px", borderRadius: "50%", fontSize: "20px", cursor: "pointer", color: "#64748b", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s" }}
                        onMouseEnter={e => { e.currentTarget.style.background = "#e2e8f0"; e.currentTarget.style.color = "#0f172a"; }}
                        onMouseLeave={e => { e.currentTarget.style.background = "#f1f5f9"; e.currentTarget.style.color = "#64748b"; }}
                      >
                        <i className="bi bi-x-lg"></i>
                      </button>
                    </div>

                    <div style={{ padding: "32px", overflowY: "auto", flex: 1 }}>
                      {/* Department Info */}
                      <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "28px" }}>
                        <div style={{ width: "48px", height: "48px", borderRadius: "12px", background: "#e0e7ff", color: "#4f46e5", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "24px" }}>
                          <i className="bi bi-gear-fill"></i>
                        </div>
                        <div>
                          <h4 style={{ margin: "0 0 4px 0", color: "#1e293b", fontSize: "18px", fontWeight: "700" }}>{selectedUploadItem.CurrentProcessName}</h4>
                          <p style={{ margin: 0, color: "#64748b", fontSize: "14px", fontWeight: "500" }}>Current active department</p>
                        </div>
                      </div>

                      {/* Vertical Audit Timeline (Temporarily Commented Out) */}
                      {/* 
                      {selectedUploadItem.Photos && selectedUploadItem.Photos.length > 0 && (
                        <div style={{ marginBottom: "32px", padding: "24px", background: "#f8fafc", borderRadius: "16px", border: "1px solid #e2e8f0" }}>
                          <h4 style={{ margin: "0 0 20px 0", color: "#1e293b", fontSize: "17px", fontWeight: "700", display: "flex", alignItems: "center" }}>
                            <i className="bi bi-clock-history me-2" style={{ color: "#4f46e5" }}></i> Audit Timeline
                          </h4>
                          <div style={{ position: "relative", paddingLeft: "16px" }}>
                            <div style={{ position: "absolute", top: 0, bottom: 0, left: "23px", width: "2px", background: "#cbd5e1", zIndex: 1 }}></div>
                            
                            {selectedUploadItem.Photos.map((p, index) => (
                              <div key={p.PhotoId} style={{ display: "flex", gap: "20px", marginBottom: index === selectedUploadItem.Photos.length - 1 ? 0 : "24px", position: "relative", zIndex: 2 }}>
                                <div style={{ width: "16px", height: "16px", borderRadius: "50%", background: "#3b82f6", border: "3px solid #fff", marginTop: "4px", flexShrink: 0, boxShadow: "0 0 0 1px #3b82f6" }}></div>
                                
                                <div style={{ flex: 1, background: "#fff", padding: "16px", borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", display: "flex", justifyContent: "space-between", gap: "16px" }}>
                                  <div>
                                    <div style={{ fontSize: "12px", fontWeight: "700", color: "#3b82f6", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "4px" }}>
                                      {p.ProcessName}
                                    </div>
                                    <div style={{ fontSize: "15px", fontWeight: "600", color: "#1e293b", marginBottom: "8px" }}>
                                      Uploaded By: {p.UploaderName || `ID ${p.UploadedBy}`}
                                    </div>
                                    <div style={{ fontSize: "13px", color: "#64748b", display: "flex", alignItems: "center" }}>
                                      <i className="bi bi-calendar-check me-1"></i> 
                                      {moment(p.UploadedAt).format("DD MMM YYYY, hh:mm A")}
                                    </div>
                                  </div>
                                  <div style={{ flexShrink: 0 }}>
                                    <a href={(process.env.REACT_APP_API_BASE_URL || "http://localhost:5050") + p.StorageKey} target="_blank" rel="noreferrer">
                                      <img 
                                        src={(process.env.REACT_APP_API_BASE_URL || "http://localhost:5050") + p.StorageKey} 
                                        alt="Proof" 
                                        style={{ width: "80px", height: "80px", objectFit: "cover", borderRadius: "8px", border: "1px solid #e2e8f0", cursor: "pointer", transition: "transform 0.2s" }} 
                                        onMouseEnter={e => e.currentTarget.style.transform = "scale(1.05)"}
                                        onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
                                      />
                                    </a>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      */}

                      {/* Photo Upload Area */}
                      <div style={{
                        border: "2px dashed #cbd5e1", borderRadius: "16px", padding: "48px 24px",
                        textAlign: "center", backgroundColor: "#f8fafc", marginBottom: "32px",
                        cursor: "pointer", position: "relative", transition: "all 0.2s"
                      }}
                      onMouseEnter={e => { e.currentTarget.style.borderColor = "#3b82f6"; e.currentTarget.style.backgroundColor = "#eff6ff"; }}
                      onMouseLeave={e => { e.currentTarget.style.borderColor = "#cbd5e1"; e.currentTarget.style.backgroundColor = "#f8fafc"; }}
                      >
                        <input 
                          type="file" accept="image/*" capture="environment" 
                          ref={quickFileInputRef} onChange={(e) => setSelectedQuickFile(e.target.files[0])}
                          style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: 0, cursor: "pointer", zIndex: 10 }} 
                        />
                        {selectedQuickFile ? (
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <img 
                              src={URL.createObjectURL(selectedQuickFile)} 
                              alt="Preview" 
                              style={{ width: "160px", height: "160px", objectFit: "cover", borderRadius: "12px", marginBottom: "16px", border: "4px solid #fff", boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)" }} 
                            />
                            <h4 style={{ margin: "0 0 8px 0", color: "#10b981", fontSize: "18px", fontWeight: "700" }}>
                              <i className="bi bi-check-circle-fill me-2"></i> Ready to Upload
                            </h4>
                            <p style={{ margin: 0, color: "#64748b", fontSize: "14px", fontWeight: "500" }}>
                              Tap again to change photo
                            </p>
                          </div>
                        ) : (
                          <>
                            <div style={{ fontSize: "48px", marginBottom: "16px", color: "#3b82f6" }}>
                              <i className="bi bi-camera-fill"></i>
                            </div>
                            <h4 style={{ margin: "0 0 8px 0", color: "#1e293b", fontSize: "18px", fontWeight: "700" }}>
                              Tap to Take Photo / Select File
                            </h4>
                            <p style={{ margin: 0, color: "#64748b", fontSize: "14px", fontWeight: "500" }}>
                              Images are automatically compressed for faster uploads.
                            </p>
                          </>
                        )}
                      </div>

                      {selectedUploadItem.CurrentProcessName === 'PRESSING' && (
                        <div style={{ marginBottom: "20px", padding: "20px", backgroundColor: "#fffbeb", borderRadius: "12px", border: "1px solid #fef3c7" }}>
                          <label style={{ display: "block", marginBottom: "8px", fontWeight: "700", color: "#92400e", fontSize: "15px" }}>
                            Select Next Route <span style={{ color: "red" }}>*</span>
                          </label>
                          <Select
                            options={[
                              { value: 'PUCTURE', label: '👉 PUCTURE (Jitu - Part Cutting)' },
                              { value: 'LOOPI', label: '👉 LOOPI (Mama - Strip Cutting)' }
                            ]}
                            value={selectedQuickRoute ? { value: selectedQuickRoute, label: selectedQuickRoute === 'PUCTURE' ? '👉 PUCTURE (Jitu - Part Cutting)' : '👉 LOOPI (Mama - Strip Cutting)' } : null}
                            onChange={(selectedOption) => setSelectedQuickRoute(selectedOption ? selectedOption.value : "")}
                            placeholder="-- Search and Choose Route --"
                            menuPosition="fixed"
                            styles={{
                              control: (base) => ({
                                ...base,
                                padding: "4px 8px",
                                borderRadius: "8px",
                                border: "1px solid #fcd34d",
                                fontSize: "15px",
                                fontWeight: "600",
                                color: "#92400e"
                              })
                            }}
                          />
                        </div>
                      )}
                    </div>

                    {/* Premium Modal Footer */}
                    <div style={{ padding: "20px 32px", borderTop: "1px solid #f1f5f9", display: "flex", justifyContent: "flex-end", gap: "16px", backgroundColor: "#f8fafc", borderBottomLeftRadius: "24px", borderBottomRightRadius: "24px", flexShrink: 0 }}>
                      <button 
                        type="button" onClick={() => setSelectedUploadItem(null)}
                        style={{ padding: "12px 24px", borderRadius: "12px", border: "1px solid #cbd5e1", backgroundColor: "#fff", color: "#475569", fontWeight: "700", fontSize: "15px", cursor: "pointer", transition: "all 0.2s" }}
                        onMouseEnter={e => { e.currentTarget.style.backgroundColor = "#f1f5f9" }}
                        onMouseLeave={e => { e.currentTarget.style.backgroundColor = "#fff" }}
                        disabled={uploadingWip}
                      >
                        Close Window
                      </button>
                      <button 
                        type="submit"
                        disabled={uploadingWip}
                        style={{ padding: "12px 24px", borderRadius: "12px", border: "none", backgroundColor: uploadingWip ? "#9ca3af" : "#22c55e", color: "#fff", fontWeight: "700", fontSize: "15px", cursor: uploadingWip ? "not-allowed" : "pointer", boxShadow: uploadingWip ? "none" : "0 4px 6px -1px rgba(34, 197, 94, 0.4)", display: "flex", alignItems: "center", gap: "8px", transition: "all 0.2s" }}
                        onMouseEnter={e => { if(!uploadingWip) e.currentTarget.style.backgroundColor = "#16a34a" }}
                        onMouseLeave={e => { if(!uploadingWip) e.currentTarget.style.backgroundColor = "#22c55e" }}
                      >
                        {uploadingWip ? (
                          <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Processing...</>
                        ) : (
                          <>Confirm & Pass <i className="bi bi-arrow-right-circle-fill"></i></>
                        )}
                      </button>
                    </div>
                  </form>
                ) : (
                  <>
                    <div className="modal-header bg-primary bg-gradient text-white border-0 rounded-top-4 px-4 py-3">
                      <h5 className="modal-title d-flex align-items-center gap-2 fw-bold mb-0" style={{ letterSpacing: "0.5px" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-images" viewBox="0 0 16 16">
                          <path d="M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"/>
                          <path d="M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V5A2 2 0 0 1 2 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-1.998 2M14 2H4a1 1 0 0 0-1 1h9.002a2 2 0 0 1 2 2v7A1 1 0 0 0 15 11V3a1 1 0 0 0-1-1M2.002 4a1 1 0 0 0-1 1v8l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094l1.777 1.947V5a1 1 0 0 0-1-1z"/>
                        </svg>
                        WIP Photo Process Queue
                      </h5>
                      <button type="button" className="btn-close btn-close-white opacity-75 shadow-none" onClick={() => { setShowWipModal(false); setSelectedUploadItem(null); }}></button>
                    </div>
                    <div className="modal-body p-4 bg-light">
                      {/* Filters Section */}
                      {wipQueueData.length > 0 && (
                        <div className="row mb-4 align-items-center bg-white p-3 rounded-3 shadow-sm border mx-0">
                          <div className="col-12">
                            <div className="input-group">
                              <span className="input-group-text bg-light border-end-0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search text-muted" viewBox="0 0 16 16">
                                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                                </svg>
                              </span>
                              <input
                                type="text"
                                className="form-control border-start-0 bg-light shadow-none"
                                placeholder="Search by Lot ID or Process..."
                                value={wipSearchTerm}
                                onChange={(e) => setWipSearchTerm(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      {wipQueueData.length === 0 ? (
                        <div className="text-center py-5 bg-white rounded-3 shadow-sm border">
                          <div className="p-3 bg-light rounded-circle d-inline-block mb-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor" className="bi bi-inbox text-primary opacity-75" viewBox="0 0 16 16">
                              <path d="M4.98 4a.5.5 0 0 0-.39.188L1.54 8H6a.5.5 0 0 1 .5.5 1.5 1.5 0 1 0 3 0A.5.5 0 0 1 10 8h4.46l-3.05-3.812A.5.5 0 0 0 11.02 4zM3.81.563A1.5 1.5 0 0 1 4.98 0h6.04a1.5 1.5 0 0 1 1.17.563l3.7 4.625a.5.5 0 0 1 .106.304l-.228 6.203a1.5 1.5 0 0 1-1.498 1.305H1.73a1.5 1.5 0 0 1-1.498-1.305L.004 5.492a.5.5 0 0 1 .106-.304zM12.18 1H3.82L1 4.5V14h14V4.5z"/>
                            </svg>
                          </div>
                          <h5 className="fw-bold text-dark">No Pending Lots</h5>
                          <p className="text-muted mb-0">Your queue is empty right now!</p>
                        </div>
                      ) : filteredWipQueue.length === 0 ? (
                        <div className="text-center py-5 bg-white rounded-3 shadow-sm border">
                          <h5 className="fw-bold text-secondary">No matching results</h5>
                          <p className="text-muted mb-0">Try adjusting your search filters.</p>
                        </div>
                      ) : (
                        <div className="table-responsive rounded-3 shadow-sm border bg-white overflow-hidden">
                          <table className="table table-hover text-center align-middle mb-0">
                            <thead className="bg-dark text-white">
                              <tr>
                                <th className="py-3 text-white fw-semibold border-0">Sr No.</th>
                                <th className="py-3 text-white fw-semibold border-0">Lot ID / ItemName</th>
                                <th className="py-3 text-white fw-semibold border-0">Current Process</th>
                                <th className="py-3 text-white fw-semibold border-0">Action</th>
                              </tr>
                            </thead>
                            <tbody className="border-top-0">
                              {filteredWipQueue.map((item, idx) => (
                                <tr key={`${item.ItemName}-${idx}`} style={{ transition: "all 0.2s ease" }}>
                                  <td className="fw-bold text-secondary">{idx + 1}</td>
                                  <td className="fw-bold text-dark">{item.ItemName}</td>
                                  <td>
                                    <span className="badge rounded-pill fw-medium px-3 py-2" style={{ backgroundColor: "#dcfce7", color: "#166534" }}>
                                      {item.CurrentProcessName}
                                    </span>
                                  </td>
                                  <td>
                                    <button className="btn btn-sm btn-primary px-3 rounded-pill fw-medium" onClick={() => handleWipUploadFromHeader(item)} style={{ display: "flex", alignItems: "center", gap: "6px", margin: "0 auto" }}>
                                      <i className="bi bi-cloud-arrow-up-fill"></i> Quick Upload
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                    
                    {/* Modal Footer */}
                    <div className="modal-footer border-0 bg-light rounded-bottom-4 px-4 py-3">
                      <button type="button" className="btn btn-secondary px-5 rounded-pill shadow-sm fw-medium" onClick={() => setShowWipModal(false)}>
                        Close
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        );
      })()}

      {showModal && (
        <div className="modal show fade-in" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.4)", backdropFilter: "blur(5px)" }}>
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" style={{ maxWidth: "1300px" }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Process Details</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body p-4">
                <div className="d-flex mb-3 gap-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Filter by Process Name or Item Name"
                    value={processItemFilter}
                    onChange={(e) => setProcessItemFilter(e.target.value)}
                  />
                  <button className="btn btn-outline-secondary" onClick={() => setProcessItemFilter("")}>Clear</button>
                </div>
                <div className="table-responsive border rounded">
                  <table className="table table-hover mb-0 text-center align-middle">
                  <thead className="bg-dark text-white">
                    <tr>
                      <th className="py-3 text-white fw-semibold border-0">Process Name</th>
                      <th className="py-3 text-white fw-semibold border-0">Item Name</th>
                      <th className="py-3 text-white fw-semibold border-0">Quantity</th>
                      <th className="py-3 text-white fw-semibold border-0">Total Hours</th>
                      <th className="py-3 text-white fw-semibold border-0">Remaining Time</th>
                      <th className="py-3 text-white fw-semibold border-0">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredProcessData.length > 0 ? (
                      filteredProcessData.map((process, index) => (
                        <tr key={index}>
                        <td>{process["PROCESS NAME"]}</td>
                        <td>{process["ITEM NAME"]}</td>
                        <td>{process["QUANTITY"]}</td>
                        <td>{process["Remaining_Hours"] || "N/A"}</td>
                        <td>
                          {liveRemainingTimes[process.ID] !== undefined
                            ? formatDuration(liveRemainingTimes[process.ID])
                            : "Calculating..."}
                        </td>
                        <td>
                          {/* ── REJECTED: Show Status only ── */}
                          {process.LotAcceptStatus === "Rejected" && process.IsIssueResolved === false ? (
                            <div className="d-flex flex-column gap-2 align-items-center">
                              <div className="badge bg-danger mb-1">🔴 Rejected by {process.LotAcceptRejectBy}</div>
                              <div className="text-muted small mb-1" style={{maxWidth:200}}>{process.LotRejectComment}</div>
                            </div>

                          /* ── PENDING ACCEPT/REJECT (Manual lot, new supervisor) ── */
                          ) : process.LotAcceptStatus === "Pending" ? (
                            <div className="mx-auto" style={{minWidth:280, maxWidth:320}}>
                              <div className="card border-0 shadow-sm w-100 text-start" style={{ borderLeft: "4px solid #0d6efd", backgroundColor: "#f8f9fa" }}>
                                <div className="card-body p-2">
                                  <div className="text-secondary fw-bold mb-1" style={{fontSize: "10px", letterSpacing: "0.5px"}}>
                                    <i className="bi bi-arrow-down-right-circle-fill text-primary me-1"></i> TRANSFER FROM
                                  </div>
                                  <div className="fw-semibold text-dark text-truncate" style={{fontSize:"13px"}}>{process.PrevSupervisorName}</div>
                                  <div className="text-muted text-truncate mb-2" style={{fontSize:"12px"}}>{process.PrevProcessName}</div>
                                  
                                  <div className="d-flex justify-content-between bg-white rounded p-1 border shadow-sm">
                                    <div className="text-center w-50 border-end">
                                      <div className="text-muted fw-semibold" style={{fontSize: "10px"}}>PRODUCED</div>
                                      <div className="fw-bold text-success" style={{fontSize:"13px"}}>{process.PrevQtyProduced}</div>
                                    </div>
                                    <div className="text-center w-50">
                                      <div className="text-muted fw-semibold" style={{fontSize: "10px"}}>DAMAGED</div>
                                      <div className="fw-bold text-danger" style={{fontSize:"13px"}}>{process.PrevQtyDamaged}</div>
                                    </div>
                                  </div>
                                  
                                  {process.PrevDonePhotos && (() => { 
                                    try { 
                                      const p=JSON.parse(process.PrevDonePhotos); 
                                      return p.length > 0 ? (
                                        <div className="mt-2 d-flex gap-2 flex-wrap">
                                          {p.map((ph,i)=>(
                                            <span 
                                              key={i} 
                                              onClick={() => setPreviewPhotoModalSrc(BASE_URL + ph)} 
                                              className="badge bg-secondary bg-opacity-75 text-white border p-2" 
                                              style={{ cursor: "pointer", transition: "0.2s" }}
                                            >
                                              <i className="bi bi-image me-1"></i> Image {i+1}
                                            </span>
                                          ))}
                                        </div>
                                      ) : null; 
                                    } catch(e){ return null; } 
                                  })()}

                                  {/* Accept / Reject buttons inside card */}
                                  <div className="d-flex gap-3 mt-3">
                                    <button className="btn btn-success btn-sm fw-bold flex-fill shadow-sm d-flex align-items-center justify-content-center gap-1 rounded-3" style={{height:36, fontSize:13, transition: "0.2s"}} onClick={() => handleOpenAccept(process)}>
                                      <i className="bi bi-check-circle-fill fs-6"></i> Accept
                                    </button>
                                    <button className="btn btn-danger btn-sm fw-bold flex-fill shadow-sm d-flex align-items-center justify-content-center gap-1 rounded-3" style={{height:36, fontSize:13, transition: "0.2s"}} onClick={() => handleOpenReject(process)}>
                                      <i className="bi bi-x-circle-fill fs-6"></i> Reject
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>

                          /* ── ACCEPTED or ERP row: Show Confirm / Done ── */
                          ) : process.ConfirmTime == null ? (
                            <button
                              className="btn btn-outline-success"
                              onClick={() => handleConfirm(process["PROCESS NAME"], process.ID)}
                              disabled={processingId !== null}
                            >
                              {processingId === `confirm_${process.ID}` ? <><span className="spinner-border spinner-border-sm me-1"></span>Confirming...</> : "Confirm"}
                            </button>
                          ) : process.CompletedTime == null ? (
                            <button
                              className="btn btn-outline-primary"
                              onClick={() => handleDone(process)}
                              disabled={processingId !== null}
                            >
                              {processingId === `done_${process.ID}` ? <><span className="spinner-border spinner-border-sm me-1"></span>Processing...</> : "Done"}
                            </button>
                          ) : (
                            <span className="badge bg-success">✅ Completed</span>
                          )}
                        </td>
                      </tr>
                    ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">No processes found.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                </div>
              </div>
              <div className="modal-footer border-0 bg-light rounded-bottom-4 px-4 py-3">
                <button className="btn btn-secondary px-5 rounded-pill shadow-sm fw-medium" onClick={() => setShowModal(false)} disabled={processingId !== null}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showDelayedModal && (
        <div className="modal show fade-in" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.4)", backdropFilter: "blur(5px)" }}>
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" style={{ maxWidth: "1300px" }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Delayed Processes</h5>
                <button type="button" className="btn-close" onClick={() => setShowDelayedModal(false)}></button>
              </div>
              <div className="modal-body p-4">
                <div className="d-flex mb-3 gap-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Filter by Supervisor, Process Name, or Item Name"
                    value={delayedFilter}
                    onChange={(e) => setDelayedFilter(e.target.value)}
                  />
                  <button className="btn btn-outline-secondary" onClick={() => setDelayedFilter("")}>Clear</button>
                </div>
                <div className="table-responsive border rounded">
                  <table className="table table-hover mb-0 text-center align-middle">
                    <thead className="bg-dark text-white">
                      <tr>
                        <th className="py-3 text-white fw-semibold border-0">Supervisor</th>
                        <th className="py-3 text-white fw-semibold border-0">Process Name</th>
                        <th className="py-3 text-white fw-semibold border-0">Item Name</th>
                        <th className="py-3 text-white fw-semibold border-0">Quantity</th>
                        <th className="py-3 text-white fw-semibold border-0">New Process Time</th>
                        <th className="py-3 text-white fw-semibold border-0">Status</th>
                        <th className="py-3 text-white fw-semibold border-0">Total Hours</th>
                        <th className="py-3 text-white fw-semibold border-0">Remaining Time</th>
                        <th className="py-3 text-white fw-semibold border-0">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredDelayedProcesses.length > 0 ? (
                        filteredDelayedProcesses.map((process, index) => (
                          <tr key={index}>
                            <td>{process["SupervisorName"]}</td>
                            <td>{process["PROCESS NAME"]}</td>
                            <td>{process["ITEM NAME"]}</td>
                            <td>{process["Quantity"]}</td>
                            <td>{process["Updated_Time"]}</td>
                            <td>
                              {process["ProcessDelayNew"] === "Yes" ? "Process Incomplete" : process["ConfirmDelay"] === "Yes" ? "Confirm Incomplete" : ""}
                            </td>
                             <td>{process["Remaining_Hours"] || "N/A"}</td>
                               <td>
                                {liveRemainingTimes[process.ID] !== undefined ? formatDuration(liveRemainingTimes[process.ID]) : "Calculating..."}
                              </td>
                            <td>
                              <button 
                                className="btn btn-success btn-sm px-4 d-inline-flex align-items-center justify-content-center gap-2 shadow-sm rounded-pill" 
                                onClick={() => handleAdminDone(process["ID"])}
                                disabled={processingId !== null}
                              >
                                {processingId === `admindone_${process["ID"]}` ? <><span className="spinner-border spinner-border-sm me-1"></span>Processing...</> : "Done"}
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center py-4 text-muted">No processes found matching your search.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-footer border-0 bg-light rounded-bottom-4 px-4 py-3">
                <button className="btn btn-secondary px-5 rounded-pill shadow-sm fw-medium" onClick={() => setShowDelayedModal(false)} disabled={processingId !== null}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showDelayed24hrModal && (
        <div className="modal show fade-in" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.4)", backdropFilter: "blur(5px)" }}>
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" style={{ maxWidth: "1300px" }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">24-Hour Delayed Processes</h5>
                <button type="button" className="btn-close" onClick={() => setShowDelayed24hrModal(false)}></button>
              </div>
              <div className="modal-body p-4">
                <div className="d-flex mb-3 gap-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Filter by Supervisor, Process Name, or Item Name"
                    value={delayed24hrFilter}
                    onChange={(e) => setDelayed24hrFilter(e.target.value)}
                  />
                  <button className="btn btn-outline-secondary" onClick={() => setDelayed24hrFilter("")}>Clear</button>
                </div>
                <div className="table-responsive border rounded">
                  <table className="table table-hover mb-0 text-center align-middle">
                    <thead className="bg-dark text-white">
                      <tr>
                        <th className="py-3 text-white fw-semibold border-0">Supervisor</th>
                        <th className="py-3 text-white fw-semibold border-0">Process Name</th>
                        <th className="py-3 text-white fw-semibold border-0">Item Name</th>
                        <th className="py-3 text-white fw-semibold border-0">Quantity</th>
                        <th className="py-3 text-white fw-semibold border-0">New Process Time</th>
                        <th className="py-3 text-white fw-semibold border-0">Total Hours</th>
                        <th className="py-3 text-white fw-semibold border-0">Remaining Time</th>
                        <th className="py-3 text-white fw-semibold border-0">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredDelayed24hrProcesses.length > 0 ? (
                        filteredDelayed24hrProcesses.map((process, index) => (
                          <tr key={index}>
                            <td>{process["SupervisorName"]}</td>
                            <td>{process["PROCESS NAME"]}</td>
                            <td>{process["ITEM NAME"]}</td>
                            <td>{process["Quantity"]}</td>
                            <td>{process["Updated_Time"]}</td>
                            <td>{process["Remaining_Hours"] || "N/A"}</td>
                              <td>
                              {liveRemainingTimes[process.ID] !== undefined ? formatDuration(liveRemainingTimes[process.ID]) : "Calculating..."}
                            </td>
                            <td>
                              <button 
                                className="btn btn-success btn-sm px-4 d-inline-flex align-items-center justify-content-center gap-2 shadow-sm rounded-pill" 
                                onClick={() => handleAdminDone(process["ID"])}
                                disabled={processingId !== null}
                              >
                                {processingId === `admindone_${process["ID"]}` ? <><span className="spinner-border spinner-border-sm me-1"></span>Processing...</> : "Done"}
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center py-4 text-muted">No processes found matching your search.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-footer border-0 bg-light rounded-bottom-4 px-4 py-3">
                <button className="btn btn-secondary px-5 rounded-pill shadow-sm fw-medium" onClick={() => setShowDelayed24hrModal(false)} disabled={processingId !== null}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      
       {showDispatchModal && (
        <div className="modal show fade-in" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.4)", backdropFilter: "blur(5px)" }}>
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" style={{ maxWidth: "1300px" }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Ready for Dispatch</h5>
                <button className="btn-close" onClick={() => setShowDispatchModal(false)}></button>
              </div>
              <div className="modal-body p-4">
                <div className="d-flex mb-3 gap-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Filter by Lot ID"
                    value={lotIdFilter}
                    onChange={(e) => setLotIdFilter(e.target.value)}
                  />
                  <button className="btn btn-outline-secondary" onClick={() => setLotIdFilter("")}>Clear</button>
                </div>
                <div className="table-responsive border rounded">
                  <table className="table table-hover mb-0 text-center align-middle">
                  <thead className="bg-dark text-white">
                    <tr>
                      <th className="py-3 text-white fw-semibold border-0">Lot ID</th>
                      <th className="py-3 text-white fw-semibold border-0">GRN No</th>
                      <th className="py-3 text-white fw-semibold border-0">Received Date</th>
                      <th className="py-3 text-white fw-semibold border-0">Quantity</th>
                      <th className="py-3 text-white fw-semibold border-0">Invoice</th>
                      <th className="py-3 text-white fw-semibold border-0">Status</th>
                      <th className="py-3 text-white fw-semibold border-0">Add Remark</th>
                      <th className="py-3 text-white fw-semibold border-0">Dispatch Details</th>
                      <th className="py-3 text-white fw-semibold border-0">Action</th>
                    </tr>
                  </thead>
                  <tbody>

                {filteredDispatchOrders.length > 0 ? (
                      filteredDispatchOrders.map((order) => (
                        <tr key={order.ID}>
                          <td>{order["LOT ID"]}</td>
                          <td>{order["SRP NO"]}</td>
                          <td>{order["RECEIVED TIME"]}</td>
                          <td>{order["QUANTITY"]}</td>
                          <td>{order["Invoice_Number"]}</td>
                          <td>{order["SO_Status"]}</td>
                          <td>
                          <input
                            type="text"
                            className="form-control"
                            value={remarkInput[order.ID] ?? order.DispatchRemark ?? ""}
                            onChange={(e) => handleRemarkChange(order.ID, e.target.value)}
                            placeholder="Add a remark"
                            disabled={processingId !== null}
                          />
                          <button 
                            className="btn btn-primary btn-sm mt-2" 
                            onClick={() => handleRemarkSubmit(order.ID)}
                            disabled={processingId !== null}
                          >
                            {processingId === `remark_${order.ID}` ? <><span className="spinner-border spinner-border-sm me-1"></span>Saving...</> : "Save"}
                          </button>
                        </td>
                        <td>{order["DispatchDetails"]}</td>
                       <td>
                       <input
                            type="number"
                            className="form-control mb-2"
                            placeholder="Enter dispatch qty"
                            min={1}
                            max={order.QUANTITY}
                            value={dispatchQtyInput[order.ID] || ""}
                            onChange={(e) => handleDispatchQtyChange(order.ID, e.target.value)}
                            disabled={processingId !== null}
                          />
                       <button
                            className="btn btn-success btn-sm"
                            onClick={() => handlePartialDispatch(order.ID)}
                            disabled={ processingId !== null || !dispatchQtyInput[order.ID] || isNaN(dispatchQtyInput[order.ID]) || parseInt(dispatchQtyInput[order.ID]) <= 0 || parseInt(dispatchQtyInput[order.ID]) > order.QUANTITY }
                          >
                            {processingId === `dispatch_${order.ID}` ? <><span className="spinner-border spinner-border-sm me-1"></span>Dispatching...</> : "Dispatch"}
                          </button>
                       </td>
                        </tr>
                      ))
                     ) : (
                      <tr>
                      <td colSpan="9" className="text-center">No orders ready for dispatch.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                </div>
              </div>
              <div className="modal-footer border-0 bg-light rounded-bottom-4 px-4 py-3">
                <button className="btn btn-secondary px-5 rounded-pill shadow-sm fw-medium" onClick={() => setShowDispatchModal(false)} disabled={processingId !== null}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════════════════════════
           DONE FORM MODAL
      ══════════════════════════════════════════════════════════ */}
      {showDoneForm && doneFormProcess && (
        <div className="modal show fade-in" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", backdropFilter: "blur(4px)", zIndex: 99999 }}>
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 800 }}>
            <div className="modal-content border-0 rounded-4 shadow-lg overflow-hidden">
              <div className="modal-header bg-white border-bottom-0 pt-4 px-4 pb-0">
                <h4 className="modal-title fw-bold text-primary d-flex align-items-center">
                  <i className="bi bi-file-earmark-check-fill me-2 fs-3"></i> Done — Production Form
                </h4>
                <button className="btn-close bg-light rounded-circle p-2" style={{marginRight: "-10px", marginTop: "-10px"}} onClick={() => setShowDoneForm(false)} />
              </div>
              <div className="modal-body p-4">
                {/* Read-only info */}
                <div className="bg-primary bg-opacity-10 border border-primary-subtle rounded-3 p-3 mb-4">
                  <div className="row g-3">
                    <div className="col-6">
                      <div className="text-secondary fw-semibold mb-1" style={{fontSize: "12px"}}>Lot ID</div>
                      <div className="fw-bold text-dark">{doneFormProcess["ITEM NAME"]}</div>
                    </div>
                    <div className="col-6">
                      <div className="text-secondary fw-semibold mb-1" style={{fontSize: "12px"}}>Process</div>
                      <div className="fw-bold text-dark">{doneFormProcess["PROCESS NAME"]}</div>
                    </div>
                    <div className="col-6">
                      <div className="text-secondary fw-semibold mb-1" style={{fontSize: "12px"}}>Total Qty</div>
                      <div className="fw-bold text-primary">{doneFormProcess.PrevQtyProduced != null ? doneFormProcess.PrevQtyProduced : doneFormProcess["QUANTITY"]}</div>
                    </div>
                    <div className="col-6">
                      <div className="text-secondary fw-semibold mb-1" style={{fontSize: "12px"}}>Supervisor</div>
                      <div className="fw-bold text-dark">{user?.Name}</div>
                    </div>
                  </div>
                </div>

                {/* Editable qty fields */}
                <div className="row g-3 mb-4">
                  <div className="col-12 col-sm-6">
                    <label className="form-label fw-bold text-dark mb-2">Qty Produced <span className="text-danger">*</span></label>
                    <input type="number" className="form-control rounded-3 border-secondary-subtle bg-light" min="0" style={{boxShadow: "none"}}
                      value={doneQtyProduced} onChange={e => setDoneQtyProduced(e.target.value)} placeholder="e.g. 2800" />
                  </div>
                  <div className="col-12 col-sm-6">
                    <label className="form-label fw-bold text-dark mb-2">Damaged + Rejected Qty</label>
                    <input type="number" className="form-control rounded-3 border-secondary-subtle bg-light" min="0" style={{boxShadow: "none"}}
                      value={doneQtyDamaged} onChange={e => setDoneQtyDamaged(e.target.value)} placeholder="e.g. 200" />
                  </div>
                </div>
                {doneQtyError && (
                  <div className="alert alert-danger py-2 px-3 small fw-semibold mb-4 rounded-3 border-danger-subtle d-flex align-items-center">
                    <i className="bi bi-exclamation-circle-fill me-2 fs-5"></i>
                    {doneQtyError}
                  </div>
                )}

                {/* Multiple photo upload */}
                <div className="mb-2">
                  <label className="form-label fw-bold text-dark mb-2">Upload Photos <span className="text-muted fw-normal" style={{fontSize: "12px"}}>(Multiple)</span> <span className="text-danger">*</span></label>
                  <input type="file" className="form-control rounded-3 border-secondary-subtle bg-light" multiple accept="image/*" style={{boxShadow: "none"}}
                    onChange={e => setDonePhotos([...donePhotos, ...Array.from(e.target.files)])} />
                  {donePhotos.length > 0 && (
                    <div className="d-flex flex-wrap gap-3 mt-3 p-3 border border-secondary-subtle rounded-3 bg-white">
                      {donePhotos.map((f, i) => (
                        <div key={i} className="position-relative" style={{ width: 80, height: 80 }}>
                          <img src={URL.createObjectURL(f)} alt={`upload-${i}`} className="img-thumbnail w-100 h-100 object-fit-cover shadow-sm p-1 rounded-3" />
                          <button type="button" className="btn btn-danger position-absolute rounded-circle shadow-sm" 
                            style={{ top: -8, right: -8, width: 24, height: 24, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                            onClick={() => setDonePhotos(donePhotos.filter((_, idx) => idx !== i))}>
                            <i className="bi bi-x" style={{ fontSize: 16 }}></i>
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Additional PUCTURE Routing Upload */}
                {showPuctureRouting && (
                  <div className="mb-2 mt-3">
                    <label className="form-label fw-bold mb-2 text-primary">PUCTURE Routing <span className="text-muted fw-normal" style={{fontSize: "12px"}}>(Optional)</span></label>
                    <input type="file" className="form-control rounded-3 border-secondary-subtle bg-light" multiple accept="image/*" style={{boxShadow: "none"}}
                      onChange={e => setPucturePhotos([...pucturePhotos, ...Array.from(e.target.files)])} />
                    {pucturePhotos.length > 0 && (
                      <div className="d-flex flex-wrap gap-3 mt-3 p-2 border border-secondary-subtle rounded-3 bg-white">
                        {pucturePhotos.map((f, i) => (
                          <div key={i} className="position-relative" style={{ width: 60, height: 60 }}>
                            <img src={URL.createObjectURL(f)} alt={`upload-${i}`} className="img-thumbnail w-100 h-100 object-fit-cover shadow-sm p-1 rounded-3" />
                            <button type="button" className="btn btn-danger position-absolute rounded-circle shadow-sm" 
                              style={{ top: -8, right: -8, width: 20, height: 20, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                              onClick={() => setPucturePhotos(pucturePhotos.filter((_, idx) => idx !== i))}>
                              <i className="bi bi-x" style={{ fontSize: 14 }}></i>
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                {/* Additional LOOPI Routing Upload */}
                {showLoopiRouting && (
                  <div className="mb-2 mt-3">
                    <label className="form-label fw-bold mb-2" style={{color: "#8b5cf6"}}>LOOPI Routing <span className="text-muted fw-normal" style={{fontSize: "12px"}}>(Optional)</span></label>
                    <input type="file" className="form-control rounded-3 border-secondary-subtle bg-light" multiple accept="image/*" style={{boxShadow: "none"}}
                      onChange={e => setLoopiPhotos([...loopiPhotos, ...Array.from(e.target.files)])} />
                    {loopiPhotos.length > 0 && (
                      <div className="d-flex flex-wrap gap-3 mt-3 p-2 border border-secondary-subtle rounded-3 bg-white">
                        {loopiPhotos.map((f, i) => (
                          <div key={i} className="position-relative" style={{ width: 60, height: 60 }}>
                            <img src={URL.createObjectURL(f)} alt={`upload-${i}`} className="img-thumbnail w-100 h-100 object-fit-cover shadow-sm p-1 rounded-3" />
                            <button type="button" className="btn btn-danger position-absolute rounded-circle shadow-sm" 
                              style={{ top: -8, right: -8, width: 20, height: 20, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                              onClick={() => setLoopiPhotos(loopiPhotos.filter((_, idx) => idx !== i))}>
                              <i className="bi bi-x" style={{ fontSize: 14 }}></i>
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="modal-footer bg-light border-top-0 p-3 px-4 d-flex justify-content-between">
                <button className="btn btn-outline-secondary px-4 fw-semibold rounded-3" onClick={() => setShowDoneForm(false)} disabled={submittingDone}>Cancel</button>
                <button className="btn btn-primary px-4 fw-bold rounded-3 shadow-sm d-flex align-items-center gap-2" onClick={handleDoneFormSubmit} disabled={submittingDone}>
                  {submittingDone ? <><span className="spinner-border spinner-border-sm" /> Submitting...</> : <><i className="bi bi-check-circle-fill"></i> Submit & Pass</>}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════════════════════════
           REJECT LOT FORM MODAL
      ══════════════════════════════════════════════════════════ */}
      {showRejectForm && rejectProcess && (
        <div className="modal show fade-in" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", backdropFilter: "blur(4px)", zIndex: 99999 }}>
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 520 }}>
            <div className="modal-content border-0 rounded-4 shadow-lg overflow-hidden">
              <div className="modal-header bg-white border-bottom-0 pt-4 px-4 pb-0">
                <h4 className="modal-title fw-bold text-danger d-flex align-items-center">
                  <i className="bi bi-exclamation-octagon-fill me-2 fs-3"></i> Reject Lot
                </h4>
                <button className="btn-close bg-light rounded-circle p-2" style={{marginRight: "-10px", marginTop: "-10px"}} onClick={() => setShowRejectForm(false)} />
              </div>
              <div className="modal-body p-4">
                <div className="d-flex flex-column gap-1 bg-danger bg-opacity-10 border border-danger-subtle rounded-3 p-3 mb-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="text-secondary fw-semibold" style={{fontSize: "13px"}}>Lot ID</span>
                    <span className="fw-bold text-dark">{rejectProcess["ITEM NAME"]}</span>
                  </div>
                  <hr className="my-1 border-secondary opacity-25" />
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="text-secondary fw-semibold" style={{fontSize: "13px"}}>From Supervisor</span>
                    <span className="fw-bold text-dark">{rejectProcess.PrevSupervisorName || rejectProcess.Supervisor}</span>
                  </div>
                </div>

                <div className="mb-4">
                  <label className="form-label fw-bold text-dark mb-2">Rejection Reason <span className="text-danger">*</span></label>
                  <textarea className="form-control rounded-3 border-secondary-subtle bg-light" rows={3} placeholder="Describe the issue clearly..."
                    style={{boxShadow: "none"}}
                    value={rejectComment} onChange={e => setRejectComment(e.target.value)} />
                </div>
                <div className="mb-2">
                  <label className="form-label fw-bold text-dark mb-2">Evidence Photos <span className="text-muted fw-normal" style={{fontSize: "12px"}}>(Optional)</span></label>
                  <input type="file" className="form-control rounded-3 border-secondary-subtle bg-light" multiple accept="image/*"
                    style={{boxShadow: "none"}}
                    onChange={e => setRejectPhotos([...rejectPhotos, ...Array.from(e.target.files)])} />
                  {rejectPhotos.length > 0 && (
                    <div className="d-flex flex-wrap gap-3 mt-3 p-3 border border-secondary-subtle rounded-3 bg-white">
                      {rejectPhotos.map((f, i) => (
                        <div key={i} className="position-relative" style={{ width: 80, height: 80 }}>
                          <img src={URL.createObjectURL(f)} alt={`upload-${i}`} className="img-thumbnail w-100 h-100 object-fit-cover shadow-sm p-1 rounded-3" />
                          <button type="button" className="btn btn-danger position-absolute rounded-circle shadow-sm" 
                            style={{ top: -8, right: -8, width: 24, height: 24, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                            onClick={() => setRejectPhotos(rejectPhotos.filter((_, idx) => idx !== i))}>
                            <i className="bi bi-x" style={{ fontSize: 16 }}></i>
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer bg-light border-top-0 p-3 px-4 d-flex justify-content-between">
                <button className="btn btn-outline-secondary px-4 fw-semibold rounded-3" onClick={() => setShowRejectForm(false)} disabled={submittingReject}>Cancel</button>
                <button className="btn btn-danger px-4 fw-bold rounded-3 shadow-sm d-flex align-items-center gap-2" onClick={handleRejectSubmit} disabled={submittingReject}>
                  {submittingReject ? <><span className="spinner-border spinner-border-sm" /> Submitting...</> : <><i className="bi bi-x-circle-fill"></i> Confirm Reject</>}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════════════════════════
           ISSUE RESOLVE FORM MODAL
      ══════════════════════════════════════════════════════════ */}
      {showResolveForm && resolveProcess && (
        <div className="modal show fade-in" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.6)", backdropFilter: "blur(6px)", zIndex: 99999 }}>
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 540 }}>
            <div className="modal-content rounded-4 shadow-lg">
              <div className="modal-header bg-warning text-dark rounded-top-4">
                <h5 className="modal-title"><i className="bi bi-tools me-2"></i> Issue Resolution</h5>
                <button className="btn-close" onClick={() => setShowResolveForm(false)} />
              </div>
              <div className="modal-body p-4">
                <div className="alert alert-danger py-2 mb-3 small">
                  <strong>Rejected by:</strong> {resolveProcess.LotAcceptRejectBy}<br/>
                  <strong>Reason:</strong> {resolveProcess.LotRejectComment}
                  {resolveProcess.RejectPhotos && (() => { try { const p = JSON.parse(resolveProcess.RejectPhotos); return p.length > 0 ? <div className="mt-1">{p.map((ph,i) => <a key={i} href={BASE_URL + ph} target="_blank" rel="noreferrer" className="me-1 btn btn-sm btn-outline-danger py-0"><i className="bi bi-image me-1"></i> Photo {i+1}</a>)}</div> : null; } catch(e){ return null; } })()}
                </div>
                <div className="mb-3">
                  <label className="form-label fw-semibold"><i className="bi bi-chat-left-text me-1"></i> Resolution Remark <span className="text-danger">*</span></label>
                  <textarea className="form-control" rows={3} placeholder="Explain how the issue was resolved..."
                    value={resolveRemark} onChange={e => setResolveRemark(e.target.value)} />
                </div>
                <div className="mb-2">
                  <label className="form-label fw-semibold"><i className="bi bi-camera me-1"></i> Evidence Photos</label>
                  <input type="file" className="form-control" multiple accept="image/*"
                    onChange={e => setResolvePhotos([...resolvePhotos, ...Array.from(e.target.files)])} />
                  {resolvePhotos.length > 0 && (
                    <div className="d-flex flex-wrap gap-3 mt-3 p-2 border rounded-3 bg-white">
                      {resolvePhotos.map((f, i) => (
                        <div key={i} className="position-relative" style={{ width: 80, height: 80 }}>
                          <img src={URL.createObjectURL(f)} alt={`upload-${i}`} className="img-thumbnail w-100 h-100 object-fit-cover shadow-sm p-1 rounded-3" />
                          <button type="button" className="btn btn-danger position-absolute rounded-circle shadow-sm" 
                            style={{ top: -8, right: -8, width: 24, height: 24, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                            onClick={() => setResolvePhotos(resolvePhotos.filter((_, idx) => idx !== i))}>
                            <i className="bi bi-x" style={{ fontSize: 16 }}></i>
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer border-0">
                <button className="btn btn-light px-4" onClick={() => setShowResolveForm(false)} disabled={submittingResolve}>Cancel</button>
                <button className="btn btn-warning px-4 fw-semibold text-dark" onClick={handleResolveSubmit} disabled={submittingResolve}>
                  {submittingResolve ? <><span className="spinner-border spinner-border-sm me-2" />Submitting...</> : <><i className="bi bi-check-lg me-1"></i> Mark Issue Solved</>}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── ACCEPT LOT MODAL (with Before Photo) ── */}
      {showAcceptForm && acceptProcess && (
        <div className="modal show fade-in" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", backdropFilter: "blur(4px)", zIndex: 99999 }}>
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 480 }}>
            <div className="modal-content border-0 rounded-4 shadow-lg overflow-hidden">
              <div className="modal-header bg-white border-bottom-0 pt-4 px-4 pb-0">
                <h4 className="modal-title fw-bold text-success d-flex align-items-center">
                  <i className="bi bi-check-circle-fill me-2 fs-3"></i> Accept & Confirm Lot
                </h4>
                <button className="btn-close bg-light rounded-circle p-2" style={{marginRight: "-10px", marginTop: "-10px"}} onClick={() => setShowAcceptForm(false)} />
              </div>
              <div className="modal-body p-4">
                <div className="d-flex flex-column gap-1 bg-success bg-opacity-10 border border-success-subtle rounded-3 p-3 mb-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="text-secondary fw-semibold" style={{fontSize: "13px"}}>Lot ID</span>
                    <span className="fw-bold text-dark">{acceptProcess["ITEM NAME"]}</span>
                  </div>
                  <hr className="my-1 border-secondary opacity-25" />
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="text-secondary fw-semibold" style={{fontSize: "13px"}}>Process</span>
                    <span className="fw-bold text-dark">{acceptProcess["PROCESS NAME"]}</span>
                  </div>
                  <hr className="my-1 border-secondary opacity-25" />
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="text-secondary fw-semibold" style={{fontSize: "13px"}}>Total Qty</span>
                    <span className="fw-bold text-success">{acceptProcess["QUANTITY"]}</span>
                  </div>
                </div>
                
                <div className="mb-2">
                  <label className="form-label fw-bold text-dark mb-2">Before Photo <span className="text-danger">*</span></label>
                  <input 
                    type="file" 
                    className="form-control rounded-3 border-secondary-subtle bg-light" 
                    accept="image/*" 
                    style={{boxShadow: "none"}}
                    onChange={e => setAcceptPhoto(e.target.files[0])} 
                  />
                  {acceptPhoto && (
                    <div className="mt-3 p-3 border border-secondary-subtle rounded-3 bg-white d-flex justify-content-center position-relative">
                      <div className="position-relative" style={{ width: 120, height: 120 }}>
                        <img 
                          src={URL.createObjectURL(acceptPhoto)} 
                          alt="Preview" 
                          className="img-thumbnail w-100 h-100 object-fit-cover shadow-sm p-1 rounded-3" 
                        />
                        <button type="button" className="btn btn-danger position-absolute rounded-circle shadow-sm" 
                          style={{ top: -8, right: -8, width: 24, height: 24, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                          onClick={() => setAcceptPhoto(null)}>
                          <i className="bi bi-x" style={{ fontSize: 16 }}></i>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer bg-light border-top-0 p-3 px-4 d-flex justify-content-between">
                <button className="btn btn-outline-secondary px-4 fw-semibold rounded-3" onClick={() => setShowAcceptForm(false)}>Cancel</button>
                <button 
                  className="btn btn-success px-4 fw-bold rounded-3 shadow-sm d-flex align-items-center gap-2" 
                  onClick={handleAcceptFormSubmit}
                  disabled={submittingAccept || !acceptPhoto}
                >
                  {submittingAccept ? <><span className="spinner-border spinner-border-sm" /> Submitting...</> : <><i className="bi bi-check-circle-fill"></i> Accept & Confirm</>}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════════════════════════
           PHOTO ROUTING NOTIFICATIONS PANEL
      ══════════════════════════════════════════════════════════ */}
      {showPhotoRoutingNotifs && (
        <div className="modal show fade-in" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", backdropFilter: "blur(4px)", zIndex: 99998 }}>
          <div className="modal-dialog modal-xl modal-dialog-centered">
            <div className="modal-content shadow-lg border-0 rounded-4 overflow-hidden">
              <div className="modal-header bg-white border-bottom">
                <h5 className="modal-title fw-bold text-primary">
                  <i className="bi bi-camera-fill me-2"></i> Photo Routing Updates
                </h5>
                <button className="btn-close" onClick={() => setShowPhotoRoutingNotifs(false)} />
              </div>
              <div className="modal-body p-4 bg-light">
                {pendingPhotoNotifs.length === 0 ? (
                  <div className="text-center py-5">
                    <i className="bi bi-check2-circle text-success" style={{ fontSize: "3rem" }}></i>
                    <h5 className="mt-3 fw-bold text-dark">All Caught Up!</h5>
                    <p className="text-muted">No pending photo routes.</p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-hover align-middle bg-white rounded-3 overflow-hidden shadow-sm">
                      <thead className="table-light text-secondary">
                        <tr>
                          <th className="fw-semibold">Lot Details</th>
                          <th className="fw-semibold">Department</th>
                          <th className="fw-semibold text-center">Photo</th>
                          <th className="fw-semibold text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pendingPhotoNotifs.map(n => {
                          let images = [];
                          try { images = JSON.parse(n.ImagePath || "[]"); } catch (e) {}

                          // Calculate 2-hour checkpoint timer
                          const createdDate = new Date(n.CreatedAt);
                          const timeLeftMs = (2 * 60 * 60 * 1000) - (currentTick - createdDate.getTime());
                          const isTicketRaised = n.TicketCount > 0;
                          
                          let timerUI = null;
                          if (isTicketRaised) {
                            timerUI = (
                              <div className="mt-2">
                                <div className="text-danger fw-bold" style={{fontSize:"13px"}}><i className="bi bi-exclamation-triangle-fill"></i> Ticket Raised (Missing Checkpoint)</div>
                                <a href={window.location.origin + "/Check-Points"} target="_blank" rel="noreferrer" className="text-decoration-none small text-primary fw-semibold mt-1 d-inline-block"><i className="bi bi-box-arrow-up-right me-1"></i>Fill Checkpoint Form</a>
                              </div>
                            );
                          } else if (timeLeftMs <= 0) {
                            timerUI = (
                              <div className="mt-2">
                                <div className="text-danger fw-bold" style={{fontSize:"13px"}}><i className="bi bi-clock-history"></i> Time Expired (Ticket raising...)</div>
                                <a href={window.location.origin + "/Check-Points"} target="_blank" rel="noreferrer" className="text-decoration-none small text-primary fw-semibold mt-1 d-inline-block"><i className="bi bi-box-arrow-up-right me-1"></i>Fill Checkpoint Form</a>
                              </div>
                            );
                          } else {
                            const h = Math.floor(timeLeftMs / (1000 * 60 * 60));
                            const m = Math.floor((timeLeftMs % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
                            const s = Math.floor((timeLeftMs % (1000 * 60)) / 1000).toString().padStart(2, '0');
                            timerUI = (
                              <div className="mt-2">
                                <div className="text-warning fw-bold" style={{fontSize:"13px"}}><i className="bi bi-stopwatch"></i> Checkpoint Time: {h}:{m}:{s} left</div>
                                <a href={window.location.origin + "/Check-Points"} target="_blank" rel="noreferrer" className="text-decoration-none small text-primary fw-semibold mt-1 d-inline-block"><i className="bi bi-box-arrow-up-right me-1"></i>Fill Checkpoint Form</a>
                              </div>
                            );
                          }

                          return (
                            <tr key={n.ID}>
                              <td>
                                <div className="fw-bold text-dark">{n.LOT_ID}</div>
                                <div className="text-muted small">
                                  {n.RoutingType} / {n.ProcessName} <br />
                                  By: <strong>{n.FromSupervisor}</strong>
                                </div>
                                {timerUI}
                              </td>
                              <td>
                                <span className="badge bg-primary bg-opacity-10 text-primary border border-primary-subtle px-3 py-2 rounded-pill">
                                  {n.Department}
                                </span>
                              </td>
                              <td className="text-center">
                                {images.length > 0 ? (
                                  <div className="d-flex flex-wrap gap-2 justify-content-center align-items-center">
                                    {images.map((img, i) => (
                                      <img
                                        key={i}
                                        src={`${BASE_URL}${img}`}
                                        alt={`Photo ${i + 1}`}
                                        className="img-thumbnail rounded-3 shadow-sm"
                                        style={{ width: "72px", height: "72px", objectFit: "cover", cursor: "pointer", border: "2px solid #dee2e6" }}
                                        onClick={() => setPreviewPhotoModalSrc(`${BASE_URL}${img}`)}
                                        title={`Image ${i + 1} — click to preview`}
                                      />
                                    ))}
                                  </div>
                                ) : <span className="text-muted small">No Photo</span>}
                              </td>
                              <td className="text-center">
                                {n.Status === 'Acknowledged' ? (
                                  <span className="badge bg-success bg-opacity-10 text-success border border-success-subtle px-3 py-2 rounded-pill fw-semibold" style={{fontSize: "12px"}}>
                                    <i className="bi bi-check2-circle me-1"></i> Forwarded ✓
                                  </span>
                                ) : (
                                  <button
                                    className="btn btn-sm btn-primary fw-bold px-3 py-2 rounded-3 shadow-sm d-flex align-items-center gap-1"
                                    onClick={() => handleOpenForward(n)}
                                  >
                                    <i className="bi bi-upload"></i> Upload & Forward
                                  </button>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════════════════════════
           WORKFLOW NOTIFICATIONS PANEL (RE_VERIFY)
      ══════════════════════════════════════════════════════════ */}
      {showWorkflowNotif && (
        <div className="modal show fade-in" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", backdropFilter: "blur(4px)", zIndex: 99998 }}>
          <div className="modal-dialog modal-xl modal-dialog-centered">
            <div className="modal-content shadow-lg">
              <div className="modal-header bg-white text-dark rounded-top border-bottom">
                <h5 className="modal-title fw-bold"><i className="bi bi-bell-fill text-warning me-2"></i> Lot Workflow Notifications</h5>
                <button className="btn-close" onClick={() => setShowWorkflowNotif(false)} />
              </div>
              <div className="modal-body p-3">
                {workflowNotifs.length === 0 ? (
                  <div className="text-center text-muted py-5">
                    <i className="bi bi-bell-slash fs-1 text-light"></i>
                    <p className="mt-3 fs-5">No pending notifications</p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-bordered table-hover mb-0 text-center align-middle" style={{fontSize: "14px"}}>
                      <thead className="table-dark text-white">
                        <tr>
                          <th>Process Name</th>
                          <th>Item Name</th>
                          <th>Quantity</th>
                          <th>Notification Alert</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {workflowNotifs.map(n => (
                          <tr key={n.ID} className={n.NotificationType === "LOT_REJECTED" ? "table-danger" : n.NotificationType === "TICKET_RAISED" ? "table-warning" : "table-success"}>
                            <td className="fw-semibold">{n.ProcessName || "-"}</td>
                            <td className="fw-bold">{n.LOT_ID}</td>
                            <td>{n.Quantity || "-"}</td>
                            <td className="text-start">
                              <div className="d-flex flex-column gap-1">
                                {n.NotificationType === "LOT_REJECTED" ? (
                                  <>
                                    <div className="badge bg-danger align-self-start p-2"><i className="bi bi-x-circle me-1"></i> Rejected by {n.FromSupervisor}</div>
                                    <div className="small fw-semibold mt-1">Reason: <span className="text-danger fw-normal">{n.RejectComment}</span></div>
                                    <div className="small text-danger fw-bold mt-1"><i className="bi bi-exclamation-triangle-fill me-1"></i> You have 2 hours to solve this issue.</div>
                                    {n.RejectPhotos && (() => { try { const p=JSON.parse(n.RejectPhotos); return p.length>0 ? <div className="mt-1 d-flex gap-1">{p.map((ph,i)=><span key={i} onClick={() => setPreviewPhotoModalSrc(BASE_URL + ph)} className="badge bg-secondary text-white border" style={{cursor:"pointer"}}><i className="bi bi-image"></i> Image {i+1}</span>)}</div>:null; }catch(e){return null;} })()}
                                  </>
                                ) : n.NotificationType === "TICKET_RAISED" ? (
                                  <>
                                    <div className="badge bg-warning text-dark align-self-start p-2"><i className="bi bi-exclamation-triangle-fill me-1"></i> Ticket Raised</div>
                                    <div className="small fw-semibold mt-1">Status: <span className="text-danger fw-normal">A ticket has been raised for this issue.</span></div>
                                    <div className="small fw-semibold mt-1">Reason: <span className="text-dark fw-normal">{n.RejectComment}</span></div>
                                    {n.RejectPhotos && (() => { try { const p=JSON.parse(n.RejectPhotos); return p.length>0 ? <div className="mt-1 d-flex gap-1">{p.map((ph,i)=><span key={i} onClick={() => setPreviewPhotoModalSrc(BASE_URL + ph)} className="badge bg-secondary text-white border" style={{cursor:"pointer"}}><i className="bi bi-image"></i> Image {i+1}</span>)}</div>:null; }catch(e){return null;} })()}
                                  </>
                                ) : n.NotificationType?.startsWith("SLA_") ? (
                                  <>
                                    <div className="badge bg-warning text-dark align-self-start p-2"><i className="bi bi-clock-history me-1"></i> SLA Reminder</div>
                                    <div className="small fw-semibold mt-1">{n.RejectComment}</div>
                                  </>
                                ) : (
                                  <>
                                    <div className="badge bg-success align-self-start p-2"><i className="bi bi-check-circle me-1"></i> Re-Verify from {n.FromSupervisor}</div>
                                    <div className="small fw-semibold mt-1">Remark: <span className="text-success fw-normal">{n.ResolutionRemark}</span></div>
                                    {n.ResolutionPhotos && (() => { try { const p=JSON.parse(n.ResolutionPhotos); return p.length>0 ? <div className="mt-1 d-flex gap-1">{p.map((ph,i)=><span key={i} onClick={() => setPreviewPhotoModalSrc(BASE_URL + ph)} className="badge bg-secondary text-white border" style={{cursor:"pointer"}}><i className="bi bi-image"></i> Image {i+1}</span>)}</div>:null; }catch(e){return null;} })()}
                                  </>
                                )}
                                <div className="text-muted" style={{fontSize:"11px"}}><i className="bi bi-clock me-1"></i>{n.CreatedAt}</div>
                              </div>
                            </td>
                            <td>
                              {n.NotificationType === "LOT_REJECTED" ? (
                                <button
                                  className="btn btn-warning btn-sm fw-bold shadow-sm"
                                  onClick={() => handleOpenResolve({
                                    ID: n.ConfirmTimeNewID,
                                    "ITEM NAME": n.LOT_ID,
                                    "PROCESS NAME": n.ProcessName,
                                    "QUANTITY": n.Quantity,
                                    LotAcceptRejectBy: n.FromSupervisor,
                                    LotRejectComment: n.RejectComment,
                                    RejectPhotos: n.RejectPhotos
                                  })}
                                >
                                  <i className="bi bi-tools me-1"></i> Issue Resolve
                                </button>
                              ) : n.NotificationType === "RE_VERIFY" ? (
                                <div className="d-flex flex-column gap-2 justify-content-center align-items-center">
                                  <button className="btn btn-success btn-sm fw-bold w-100 shadow-sm d-flex justify-content-center align-items-center" onClick={() => handleReVerify(n.ID, n.ConfirmTimeNewID, "Approved")}><i className="bi bi-check-circle-fill me-2" style={{ fontSize: "15px" }}></i> Approve</button>
                                  <button className="btn btn-danger btn-sm fw-bold w-100 shadow-sm d-flex justify-content-center align-items-center"  onClick={() => handleReVerify(n.ID, n.ConfirmTimeNewID, "RejectedAgain")}><i className="bi bi-x-circle-fill me-2" style={{ fontSize: "15px" }}></i> Reject Again</button>
                                </div>
                              ) : null}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              <div className="modal-footer bg-light border-top">
                <button className="btn btn-secondary px-4 fw-semibold" onClick={() => setShowWorkflowNotif(false)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════════════════════════
           UPLOAD & FORWARD PHOTO MODAL — Premium UI
      ══════════════════════════════════════════════════════════ */}
      {showForwardModal && forwardNotif && (
        <div className="modal show" style={{ display: "block", backgroundColor: "rgba(10,10,20,0.65)", backdropFilter: "blur(6px)", zIndex: 99999 }}>
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" style={{ maxWidth: 580 }}>
            <div className="modal-content border-0 shadow-lg overflow-hidden" style={{ borderRadius: 20 }}>

              {/* ── White Header ── */}
              <div style={{ background: "#fff", padding: "18px 22px 14px", borderBottom: "1px solid #e2e8f0" }}>
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <div style={{ background: "#eff6ff", borderRadius: 8, width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <i className="bi bi-send-fill text-primary" style={{ fontSize: 15 }}></i>
                      </div>
                      <h5 className="fw-bold mb-0 text-dark" style={{ fontSize: 17 }}>Upload & Forward Photos</h5>
                    </div>
                    <div className="d-flex align-items-center gap-2 mt-1">
                      <span style={{ background: "#eff6ff", color: "#2563eb", fontSize: 11, fontWeight: 600, padding: "2px 10px", borderRadius: 20, letterSpacing: 0.5 }}>
                        {forwardNotif.RoutingType}
                      </span>
                      <span className="text-muted" style={{ fontSize: 12 }}>
                        {forwardNotif.LOT_ID} &bull; {forwardNotif.ProcessName}
                      </span>
                    </div>
                  </div>
                  <button
                    style={{ background: "#f1f5f9", border: "none", borderRadius: 8, width: 30, height: 30, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}
                    onClick={() => setShowForwardModal(false)} disabled={submittingForward}>
                    <i className="bi bi-x-lg text-secondary" style={{ fontSize: 14 }}></i>
                  </button>
                </div>

                {/* Chain Flow Indicator */}
                <div className="d-flex align-items-center gap-2 mt-3 p-2 rounded-3" style={{ background: "#f8fafc", border: "1px solid #e2e8f0" }}>
                  <div style={{ background: "#e2e8f0", borderRadius: 6, padding: "3px 10px", fontSize: 11, color: "#475569", fontWeight: 600 }}>
                    <i className="bi bi-person-fill me-1"></i>{forwardNotif.FromSupervisor}
                  </div>
                  <i className="bi bi-arrow-right text-secondary" style={{ fontSize: 12 }}></i>
                  <div style={{ background: "#dcfce7", border: "1px solid #86efac", borderRadius: 6, padding: "3px 10px", fontSize: 11, color: "#15803d", fontWeight: 600 }}>
                    <i className="bi bi-person-fill me-1"></i>You
                  </div>
                  {getNextSupervisor(forwardNotif.RoutingType, user?.EmployeeID) && (
                    <>
                      <i className="bi bi-arrow-right text-secondary" style={{ fontSize: 12 }}></i>
                      <div style={{ background: "#fef9c3", border: "1px solid #fde047", borderRadius: 6, padding: "3px 10px", fontSize: 11, color: "#854d0e", fontWeight: 600 }}>
                        <i className="bi bi-person-fill me-1"></i>{getNextSupervisor(forwardNotif.RoutingType, user?.EmployeeID)}
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div className="modal-body p-0" style={{ background: "#f8fafc" }}>

                {/* ── Received Photos Section ── */}
                {(() => {
                  let imgs = [];
                  try { imgs = JSON.parse(forwardNotif.ImagePath || "[]"); } catch(e) {}
                  return imgs.length > 0 ? (
                    <div style={{ background: "#fff", margin: "16px 20px 0", borderRadius: 14, border: "1px solid #e2e8f0", overflow: "hidden" }}>
                      <div style={{ background: "linear-gradient(90deg,#f0f9ff,#e0f2fe)", padding: "10px 16px", borderBottom: "1px solid #bae6fd" }}>
                        <span style={{ fontSize: 12, fontWeight: 700, color: "#0369a1", letterSpacing: 0.3 }}>
                          <i className="bi bi-images me-2"></i>RECEIVED FROM {forwardNotif.FromSupervisor?.toUpperCase()}
                        </span>
                      </div>
                      <div className="d-flex flex-wrap gap-2 p-3">
                        {imgs.map((img, i) => (
                          <div key={i} style={{ position: "relative" }}>
                            <img src={`${BASE_URL}${img}`} alt={`recv-${i}`}
                              style={{ width: 72, height: 72, objectFit: "cover", borderRadius: 10, cursor: "pointer", border: "2px solid #bae6fd", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
                              onClick={() => setPreviewPhotoModalSrc(`${BASE_URL}${img}`)} />
                            <div style={{ position: "absolute", bottom: 3, right: 3, background: "rgba(0,0,0,0.55)", borderRadius: 4, fontSize: 9, color: "#fff", padding: "1px 5px", fontWeight: 700 }}>
                              {i + 1}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : null;
                })()}

                {/* ── Upload New Photos Section ── */}
                <div style={{ margin: "16px 20px 16px", borderRadius: 14, border: "1px solid #e2e8f0", overflow: "hidden", background: "#fff" }}>
                  <div style={{ background: "linear-gradient(90deg,#f0fdf4,#dcfce7)", padding: "10px 16px", borderBottom: "1px solid #bbf7d0" }}>
                    <span style={{ fontSize: 12, fontWeight: 700, color: "#15803d", letterSpacing: 0.3 }}>
                      <i className="bi bi-cloud-upload-fill me-2"></i>YOUR INSPECTION PHOTOS <span style={{ color: "#ef4444" }}>*</span>
                    </span>
                    {getNextSupervisor(forwardNotif.RoutingType, user?.EmployeeID) ? (
                      <span style={{ fontSize: 11, color: "#16a34a", marginLeft: 6 }}>(Will be forwarded to next dept.)</span>
                    ) : (
                      <span style={{ fontSize: 11, color: "#16a34a", marginLeft: 6 }}>(Final inspection photos)</span>
                    )}
                  </div>

                  <div className="p-3">
                    {/* Dropzone style upload area */}
                    <label htmlFor="fwdFileInput" style={{
                      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
                      border: `2px dashed ${forwardPhotos.length > 0 ? "#22c55e" : "#93c5fd"}`,
                      borderRadius: 12, padding: "20px 16px", cursor: "pointer",
                      background: forwardPhotos.length > 0 ? "#f0fdf4" : "#eff6ff",
                      transition: "all 0.2s"
                    }}>
                      <i className={`bi ${forwardPhotos.length > 0 ? "bi-check-circle-fill text-success" : "bi-camera-fill text-primary"}`} style={{ fontSize: 28 }}></i>
                      <div style={{ fontSize: 13, fontWeight: 600, color: forwardPhotos.length > 0 ? "#15803d" : "#1d4ed8", marginTop: 8 }}>
                        {forwardPhotos.length > 0 ? `${forwardPhotos.length} photo${forwardPhotos.length > 1 ? "s" : ""} selected` : "Tap to capture / select photos"}
                      </div>
                      <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 3 }}>Supports JPG, PNG, HEIC • Max 2MB each</div>
                      <input id="fwdFileInput" type="file" multiple accept="image/*" style={{ display: "none" }}
                        onChange={e => setForwardPhotos([...forwardPhotos, ...Array.from(e.target.files)])} />
                    </label>

                    {/* Preview Grid */}
                    {forwardPhotos.length > 0 && (
                      <div className="d-flex flex-wrap gap-2 mt-3">
                        {forwardPhotos.map((f, i) => (
                          <div key={i} style={{ position: "relative", width: 72, height: 72 }}>
                            <img src={URL.createObjectURL(f)} alt={`fwd-${i}`}
                              style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 10, border: "2px solid #bbf7d0", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }} />
                            <button type="button" onClick={() => setForwardPhotos(forwardPhotos.filter((_, idx) => idx !== i))}
                              style={{ position: "absolute", top: -7, right: -7, width: 20, height: 20, borderRadius: "50%", background: "#ef4444", border: "2px solid #fff", color: "#fff", fontSize: 11, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", boxShadow: "0 1px 4px rgba(0,0,0,0.2)" }}>
                              <i className="bi bi-x"></i>
                            </button>
                          </div>
                        ))}
                        {/* Add more button */}
                        <label htmlFor="fwdFileInput" style={{ width: 72, height: 72, borderRadius: 10, border: "2px dashed #93c5fd", background: "#eff6ff", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                          <i className="bi bi-plus-lg text-primary" style={{ fontSize: 18 }}></i>
                          <span style={{ fontSize: 9, color: "#3b82f6", fontWeight: 600, marginTop: 2 }}>ADD MORE</span>
                        </label>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* ── Footer ── */}
              <div style={{ background: "#fff", borderTop: "1px solid #e2e8f0", padding: "14px 20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <button onClick={() => setShowForwardModal(false)} disabled={submittingForward}
                  style={{ background: "transparent", border: "1.5px solid #cbd5e1", borderRadius: 10, padding: "8px 22px", fontWeight: 600, fontSize: 13, color: "#64748b", cursor: "pointer" }}>
                  Cancel
                </button>
                <button onClick={handleForwardSubmit} 
                  disabled={submittingForward || forwardPhotos.length === 0}
                  style={{
                    background: (submittingForward || forwardPhotos.length === 0) ? "#94a3b8" : "linear-gradient(135deg, #1e3a8a, #3b82f6)",
                    border: "none", borderRadius: 10, padding: "9px 26px",
                    fontWeight: 700, fontSize: 13, color: "#fff", 
                    cursor: (submittingForward || forwardPhotos.length === 0) ? "not-allowed" : "pointer",
                    display: "flex", alignItems: "center", gap: 8, 
                    boxShadow: forwardPhotos.length > 0 ? "0 4px 14px rgba(59,130,246,0.4)" : "none",
                    transition: "all 0.2s"
                  }}>
                  {submittingForward
                    ? <><span className="spinner-border spinner-border-sm"></span> Processing...</>
                    : getNextSupervisor(forwardNotif.RoutingType, user?.EmployeeID) 
                        ? <><i className="bi bi-send-fill"></i> Forward to Next Dept</>
                        : <><i className="bi bi-check2-circle"></i> Acknowledge & Finish</>
                  }
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

      {/* ── IMAGE PREVIEW MODAL ── */}
      {previewPhotoModalSrc && (
        <div className="modal show fade-in" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.8)", backdropFilter: "blur(4px)", zIndex: 100000 }} onClick={() => setPreviewPhotoModalSrc(null)}>
          <div className="modal-dialog modal-dialog-centered modal-lg" onClick={e => e.stopPropagation()}>
            <div className="modal-content bg-transparent border-0 shadow-none">
              <div className="modal-header border-0 pb-0 justify-content-end">
                <button className="btn-close btn-close-white" style={{ filter: "invert(1)" }} onClick={() => setPreviewPhotoModalSrc(null)} />
              </div>
              <div className="modal-body text-center p-0 mt-2">
                <img 
                  src={previewPhotoModalSrc?.startsWith('http') ? previewPhotoModalSrc : `${process.env.REACT_APP_API_BASE_PATH || 'https://wip.fibrebondindustries.com/backend'}${previewPhotoModalSrc?.startsWith('/') ? '' : '/'}${previewPhotoModalSrc}`} 
                  alt="Preview" 
                  className="img-fluid rounded shadow-lg" 
                  style={{ maxHeight: "80vh", objectFit: "contain" }} 
                />
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Header;
